/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8081".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccountBean
 */
export interface AccountBean {
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    id?: number;
    /**
     * Account username
     * @type {string}
     * @memberof AccountBean
     */
    username: string;
    /**
     * Account password
     * @type {string}
     * @memberof AccountBean
     */
    password?: string;
    /**
     * Account email
     * @type {string}
     * @memberof AccountBean
     */
    email: string;
    /**
     * Account timezoneId
     * @type {string}
     * @memberof AccountBean
     */
    timezoneId?: string;
    /**
     * User access role
     * @type {string}
     * @memberof AccountBean
     */
    role?: AccountBean.RoleEnum;
    /**
     * Registered Dsp
     * @type {number}
     * @memberof AccountBean
     */
    dspId?: number;
    /**
     * Registered Publisher
     * @type {number}
     * @memberof AccountBean
     */
    publisherId?: number;
    /**
     * Wallet ID
     * @type {string}
     * @memberof AccountBean
     */
    walletId?: string;
    /**
     * Public validation key
     * @type {string}
     * @memberof AccountBean
     */
    publicValidationKey?: string;
}

/**
 * @export
 * @namespace AccountBean
 */
export namespace AccountBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        Admin = <any> 'Admin',
        Publisher = <any> 'Publisher',
        Dsp = <any> 'Dsp',
        Reporting = <any> 'Reporting'
    }
}
/**
 * User credentials
 * @export
 * @interface AuthDataBean
 */
export interface AuthDataBean {
    /**
     * 
     * @type {string}
     * @memberof AuthDataBean
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthDataBean
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface DealBean
 */
export interface DealBean {
    /**
     * 
     * @type {number}
     * @memberof DealBean
     */
    id?: number;
    /**
     * ID of Ad Unit
     * @type {string}
     * @memberof DealBean
     */
    adUnitId: string;
    /**
     * Deal ID
     * @type {string}
     * @memberof DealBean
     */
    dealId: string;
    /**
     * Whitelist of buyer seats
     * @type {string}
     * @memberof DealBean
     */
    wseat?: string;
    /**
     * Publisher ID
     * @type {number}
     * @memberof DealBean
     */
    publisherId: number;
    /**
     * Deal Name
     * @type {string}
     * @memberof DealBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    endDate?: string;
    /**
     * Minimum bid for this impression expressed in CPM
     * @type {number}
     * @memberof DealBean
     */
    bidFloor?: number;
    /**
     * Ids of Iab Categories
     * @type {Array<number>}
     * @memberof DealBean
     */
    geoRegion?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    emailId?: string;
}
/**
 * @export
 * @interface ClusterKeyValue
 */
export interface ClusterKeyValue {
    key: string;
    value: string;
}
/**
 * @export
 * @interface ClusterEndpointBean
 */
export interface ClusterEndpointBean {
    cluster: string;
    endpointUrl: string;
    defaultEndpoint: boolean;
}
/**
 * @export
 * @interface DictionaryOption
 */
export interface DictionaryOption {
    name: string;
    value: string;
}
/**
 *
 * @export
 * @interface DspBean
 */
export interface DspBean {
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    id?: number;
    /**
     * Type of DSP. Simple OpenRTB or DSP specific
     * @type {string}
     * @memberof DspBean
     */
    dspType: DspBean.DspTypeEnum;
    /**
     * Name of DSP
     * @type {string}
     * @memberof DspBean
     */
    name: string;
    /**
     * Dsp email
     * @type {string}
     * @memberof DspBean
     */
    email: string;
    /**
     * URL to DSP
     * @type {string}
     * @memberof DspBean
     */
    endpointUrl: string;
    /**
     * Activity flag
     * @type {boolean}
     * @memberof DspBean
     */
    active: boolean;
    /**
     * Maximum time in milliseconds the exchange allows
     * @type {number}
     * @memberof DspBean
     */
    tmax: number;
    /**
     * Maximum queries per second allowed
     * @type {number}
     * @memberof DspBean
     */
    maxQps?: number;
    /**
     * Using of gzip compressed bid
     * @type {boolean}
     * @memberof DspBean
     */
    gzipCompression: boolean;
    /**
     * Is this dsp is a Mini Exchange
     * @type {boolean}
     * @memberof DspBean
     */
    miniExchange: boolean;
    /**
     * 
     * @type {AuthDataBean}
     * @memberof DspBean
     */
    authDataBean?: AuthDataBean;
    /**
     * Validation request flag
     * @type {boolean}
     * @memberof DspBean
     */
    validation: boolean;
    /**
     * DSP fee
     * @type {number}
     * @memberof DspBean
     */
    fee: number;
    /**
     * Notification type on Win event: nurl, burl, both
     * @type {Array<string>}
     * @memberof DspBean
     */
    winNotification?: Array<DspBean.WinNotificationEnum>;
    /**
     * DSP Cookie sync endpoint
     * @type {string}
     * @memberof DspBean
     */
    userSyncEndpoint?: string;
    /**
     * DSP Cookie sync user ID macro
     * @type {string}
     * @memberof DspBean
     */
    userSyncUidMacro?: string;
    /**
     * Public validation key
     * @type {string}
     * @memberof DspBean
     */
    publicValidationKey?: string;
    /**
     * Dsp timezoneId
     * @type {string}
     * @memberof DspBean
     */
    timezoneId?: string;
    /**
     * Limit of period for Athena reports
     * @type {number}
     * @memberof DspBean
     */
    athenaPeriodLimit?: number;
    /**
     * Remaining period limit for Athena reports in the current period
     * @type {number}
     * @memberof DspBean
     */
    athenaPeriodLeft?: number;
    /**
     * Limit the number of validation report
     * @type {number}
     * @memberof DspBean
     */
    athenaValidationsLimit?: number;
    /**
     * Remaining number of verification reports in the current period
     * @type {number}
     * @memberof DspBean
     */
    athenaValidationsLeft?: number;
    /**
     * Limit validity month
     * @type {number}
     * @memberof DspBean
     */
    reportLimitsMonth?: number;
    /**
     * Cluster endpoint configurations
     * @type {Array<ClusterEndpointBean>}
     * @memberof DspBean
     */
    clusterEndpoints?: Array<ClusterEndpointBean>;
    /**
     * Device targeting options for the DSP
     * @type {Array<string>}
     * @memberof DspBean
     */
    targetDeviceTypes?: Array<string>;
    /**
     * OS targeting options for the DSP
     * @type {Array<string>}
     * @memberof DspBean
     */
    targetOperatingSystems?: Array<string>;
}

/**
 * @export
 * @namespace DspBean
 */
export namespace DspBean {
    /**
     * @export
     * @enum {string}
     */
    export enum DspTypeEnum {
        OpenRTB = <any> 'OpenRTB',
        Alkimi = <any> 'Alkimi',
        BidSwitch = <any> 'BidSwitch',
        Equativ = <any> 'Equativ'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WinNotificationEnum {
        Nurl = <any> 'Nurl',
        Burl = <any> 'Burl'
    }
}
/**
 * 
 * @export
 * @interface DspReportKeyColumnDescription
 */
export interface DspReportKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof DspReportKeyColumnDescription
     */
    column?: DspReportKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof DspReportKeyColumnDescription
     */
    order?: DspReportKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DspReportKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof DspReportKeyColumnDescription
     */
    where?: KeyFilterClause;
}

/**
 * @export
 * @namespace DspReportKeyColumnDescription
 */
export namespace DspReportKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Publisher = <any> 'Publisher',
        Date = <any> 'Date',
        PublisherId = <any> 'PublisherId',
        Dsp = <any> 'Dsp',
        DspId = <any> 'DspId',
        FourHourly = <any> 'FourHourly',
        Daily = <any> 'Daily',
        Weekly = <any> 'Weekly',
        Monthly = <any> 'Monthly',
        Yearly = <any> 'Yearly',
        Seat = <any> 'Seat',
        Size = <any> 'Size',
        MediaType = <any> 'MediaType',
        Domain = <any> 'Domain',
        MobileAppId = <any> 'MobileAppId',
        DeviceType = <any> 'DeviceType',
        Country = <any> 'Country',
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface DspReportRequestParameters
 */
export interface DspReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<DspReportKeyColumnDescription>}
     * @memberof DspReportRequestParameters
     */
    keyColumns?: Array<DspReportKeyColumnDescription>;
    /**
     * 
     * @type {Array<DspReportValueColumnDescription>}
     * @memberof DspReportRequestParameters
     */
    valueColumns?: Array<DspReportValueColumnDescription>;
}

/**
 * @export
 * @namespace DspReportRequestParameters
 */
export namespace DspReportRequestParameters {
}
/**
 * 
 * @export
 * @interface DspReportValueColumnDescription
 */
export interface DspReportValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof DspReportValueColumnDescription
     */
    column?: DspReportValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof DspReportValueColumnDescription
     */
    order?: DspReportValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DspReportValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof DspReportValueColumnDescription
     */
    where?: ValueFilterClause;
}

/**
 * @export
 * @namespace DspReportValueColumnDescription
 */
export namespace DspReportValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Requests = <any> 'Requests',
        AdSlotRequests = <any> 'AdSlotRequests',
        Bids = <any> 'Bids',
        Wins = <any> 'Wins',
        WinRate = <any> 'WinRate',
        Impressions = <any> 'Impressions',
        PageImpressions = <any> 'PageImpressions',
        SpendNet = <any> 'SpendNet',
        SpendGross = <any> 'SpendGross',
        AverageCpm = <any> 'AverageCpm',
        AvgBidFloor = <any> 'AvgBidFloor',
        AvgWinPrice = <any> 'AvgWinPrice',
        AvgBidPrice = <any> 'AvgBidPrice',
        AvgWinBidDif = <any> 'AvgWinBidDif',
        ClickThroughRate = <any> 'ClickThroughRate',
        CostPerClick = <any> 'CostPerClick',
        ViewThroughRate = <any> 'ViewThroughRate',
        View = <any> 'View',
        Click = <any> 'Click',
        VastStart = <any> 'VastStart',
        VastFirstQ = <any> 'VastFirstQ',
        VastMidpoint = <any> 'VastMidpoint',
        VastThirdQ = <any> 'VastThirdQ',
        VastComplete = <any> 'VastComplete',
        VastError = <any> 'VastError',
        PrebidBidFloor = <any> 'PrebidBidFloor',
        DspWinPrice = <any> 'DspWinPrice',
        DspBidPrice = <any> 'DspBidPrice',
        DspWinBidDif = <any> 'DspWinBidDif',
        SpendWin = <any> 'SpendWin',
        SpendImpr = <any> 'SpendImpr',
        DspFeeWin = <any> 'DspFeeWin',
        DspFeeImpr = <any> 'DspFeeImpr',
        FillRate = <any> 'FillRate',
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface HouseAdSizeBean
 */
export interface HouseAdSizeBean {
    /**
     * 
     * @type {number}
     * @memberof HouseAdSizeBean
     */
    id?: number;
    /**
     * Name of Ad Size
     * @type {string}
     * @memberof HouseAdSizeBean
     */
    name: string;
    /**
     * Width
     * @type {number}
     * @memberof HouseAdSizeBean
     */
    width: number;
    /**
     * Height
     * @type {number}
     * @memberof HouseAdSizeBean
     */
    height: number;
}
/**
 * 
 * @export
 * @interface HouseCreativeBean
 */
export interface HouseCreativeBean {
    /**
     * 
     * @type {number}
     * @memberof HouseCreativeBean
     */
    id?: number;
    /**
     * Name of Creative
     * @type {string}
     * @memberof HouseCreativeBean
     */
    name: string;
    /**
     * Format type
     * @type {string}
     * @memberof HouseCreativeBean
     */
    format: HouseCreativeBean.FormatEnum;
    /**
     * Active
     * @type {boolean}
     * @memberof HouseCreativeBean
     */
    active: boolean;
    /**
     * Ad Code of Creative
     * @type {string}
     * @memberof HouseCreativeBean
     */
    adCode: string;
    /**
     * Secure
     * @type {boolean}
     * @memberof HouseCreativeBean
     */
    secure: boolean;
    /**
     * Position
     * @type {Array<string>}
     * @memberof HouseCreativeBean
     */
    position: Array<HouseCreativeBean.PositionEnum>;
    /**
     * Linked Ad Size
     * @type {number}
     * @memberof HouseCreativeBean
     */
    houseAdSize: number;
}

/**
 * @export
 * @namespace HouseCreativeBean
 */
export namespace HouseCreativeBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        Audio = <any> 'Audio'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionEnum {
        Above = <any> 'Above',
        Below = <any> 'Below',
        Fullscreen = <any> 'Fullscreen'
    }
}
/**
 * 
 * @export
 * @interface IabCategoryBean
 */
export interface IabCategoryBean {
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    parentId?: number;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface CountryBean
 */
export interface CountryBean {
    /**
     * 
     * @type {number}
     * @memberof CountryBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    iso3?: string;
}
/**
 * 
 * @export
 * @interface ItemResponseAccountBeanObject
 */
export interface ItemResponseAccountBeanObject {
    /**
     * 
     * @type {AccountBean}
     * @memberof ItemResponseAccountBeanObject
     */
    data?: AccountBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAccountBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseBooleanObject
 */
export interface ItemResponseBooleanObject {
    /**
     * 
     * @type {boolean}
     * @memberof ItemResponseBooleanObject
     */
    data?: boolean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseBooleanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDealBeanObject
 */
export interface ItemResponseDealBeanObject {
    /**
     * 
     * @type {DealBean}
     * @memberof ItemResponseDealBeanObject
     */
    data?: DealBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDealBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDspBeanObject
 */
export interface ItemResponseDspBeanObject {
    /**
     * 
     * @type {DspBean}
     * @memberof ItemResponseDspBeanObject
     */
    data?: DspBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDspBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseHouseAdSizeBeanObject
 */
export interface ItemResponseHouseAdSizeBeanObject {
    /**
     * 
     * @type {HouseAdSizeBean}
     * @memberof ItemResponseHouseAdSizeBeanObject
     */
    data?: HouseAdSizeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseHouseAdSizeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseHouseCreativeBeanObject
 */
export interface ItemResponseHouseCreativeBeanObject {
    /**
     * 
     * @type {HouseCreativeBean}
     * @memberof ItemResponseHouseCreativeBeanObject
     */
    data?: HouseCreativeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseHouseCreativeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseNodeBeanObject
 */
export interface ItemResponseNodeBeanObject {
    /**
     * 
     * @type {NodeBean}
     * @memberof ItemResponseNodeBeanObject
     */
    data?: NodeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseNodeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponsePublisherBeanObject
 */
export interface ItemResponsePublisherBeanObject {
    /**
     * 
     * @type {PublisherBean}
     * @memberof ItemResponsePublisherBeanObject
     */
    data?: PublisherBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponsePublisherBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponsePublisherGroupBeanObject
 */
export interface ItemResponsePublisherGroupBeanObject {
    /**
     * 
     * @type {PublisherGroupBean}
     * @memberof ItemResponsePublisherGroupBeanObject
     */
    data?: PublisherGroupBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponsePublisherGroupBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseReportBeanObject
 */
export interface ItemResponseReportBeanObject {
    /**
     * 
     * @type {ReportBean}
     * @memberof ItemResponseReportBeanObject
     */
    data?: ReportBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseReportBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseReportTemplateRequestObject
 */
export interface ItemResponseReportTemplateRequestObject {
    /**
     * 
     * @type {ReportTemplateRequest}
     * @memberof ItemResponseReportTemplateRequestObject
     */
    data?: ReportTemplateRequest;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseReportTemplateRequestObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseReportTemplateRequestObjectObject
 */
export interface ItemResponseReportTemplateRequestObjectObject {
    /**
     * 
     * @type {ReportTemplateRequestObject}
     * @memberof ItemResponseReportTemplateRequestObjectObject
     */
    data?: ReportTemplateRequestObject;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseReportTemplateRequestObjectObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSOVTemplateBeanObject
 */
export interface ItemResponseSOVTemplateBeanObject {
    /**
     * 
     * @type {SOVTemplateBean}
     * @memberof ItemResponseSOVTemplateBeanObject
     */
    data?: SOVTemplateBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSOVTemplateBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseScheduledReportRequestObject
 */
export interface ItemResponseScheduledReportRequestObject {
    /**
     * 
     * @type {ScheduledReportRequest}
     * @memberof ItemResponseScheduledReportRequestObject
     */
    data?: ScheduledReportRequest;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseScheduledReportRequestObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseScheduledReportRequestObjectObject
 */
export interface ItemResponseScheduledReportRequestObjectObject {
    /**
     * 
     * @type {ScheduledReportRequestObject}
     * @memberof ItemResponseScheduledReportRequestObjectObject
     */
    data?: ScheduledReportRequestObject;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseScheduledReportRequestObjectObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSetObject
 */
export interface ItemResponseSetObject {
    /**
     * 
     * @type {Array<any>}
     * @memberof ItemResponseSetObject
     */
    data?: Array<any>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSetObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseStringObject
 */
export interface ItemResponseStringObject {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseStringObject
     */
    data?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseStringObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseUUIDObject
 */
export interface ItemResponseUUIDObject {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseUUIDObject
     */
    data?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseUUIDObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface KeyFilterClause
 */
export interface KeyFilterClause {
    /**
     * 
     * @type {string}
     * @memberof KeyFilterClause
     */
    type?: KeyFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof KeyFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace KeyFilterClause
 */
export namespace KeyFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        In = <any> 'in',
        Between = <any> 'between',
        Equals = <any> 'equals',
        NotEquals = <any> 'notEquals'
    }
}
/**
 * 
 * @export
 * @interface LanguageBean
 */
export interface LanguageBean {
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ListPagination
 */
export interface ListPagination {
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface ListResponseAccountBean
 */
export interface ListResponseAccountBean {
    /**
     * 
     * @type {Array<ItemResponseAccountBeanObject>}
     * @memberof ListResponseAccountBean
     */
    data?: Array<ItemResponseAccountBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAccountBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseDealBean
 */
export interface ListResponseDealBean {
    /**
     * 
     * @type {Array<ItemResponseDealBeanObject>}
     * @memberof ListResponseDealBean
     */
    data?: Array<ItemResponseDealBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseDealBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseDspBean
 */
export interface ListResponseDspBean {
    /**
     * 
     * @type {Array<ItemResponseDspBeanObject>}
     * @memberof ListResponseDspBean
     */
    data?: Array<ItemResponseDspBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseDspBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseHouseAdSizeBean
 */
export interface ListResponseHouseAdSizeBean {
    /**
     * 
     * @type {Array<ItemResponseHouseAdSizeBeanObject>}
     * @memberof ListResponseHouseAdSizeBean
     */
    data?: Array<ItemResponseHouseAdSizeBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseHouseAdSizeBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseHouseCreativeBean
 */
export interface ListResponseHouseCreativeBean {
    /**
     * 
     * @type {Array<ItemResponseHouseCreativeBeanObject>}
     * @memberof ListResponseHouseCreativeBean
     */
    data?: Array<ItemResponseHouseCreativeBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseHouseCreativeBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseNodeBean
 */
export interface ListResponseNodeBean {
    /**
     * 
     * @type {Array<ItemResponseNodeBeanObject>}
     * @memberof ListResponseNodeBean
     */
    data?: Array<ItemResponseNodeBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseNodeBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponsePublisherBean
 */
export interface ListResponsePublisherBean {
    /**
     * 
     * @type {Array<ItemResponsePublisherBeanObject>}
     * @memberof ListResponsePublisherBean
     */
    data?: Array<ItemResponsePublisherBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponsePublisherBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponsePublisherGroupBean
 */
export interface ListResponsePublisherGroupBean {
    /**
     * 
     * @type {Array<ItemResponsePublisherGroupBeanObject>}
     * @memberof ListResponsePublisherGroupBean
     */
    data?: Array<ItemResponsePublisherGroupBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponsePublisherGroupBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseReportTemplateRequestObject
 */
export interface ListResponseReportTemplateRequestObject {
    /**
     * 
     * @type {Array<ItemResponseReportTemplateRequestObjectObject>}
     * @memberof ListResponseReportTemplateRequestObject
     */
    data?: Array<ItemResponseReportTemplateRequestObjectObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseReportTemplateRequestObject
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSOVTemplateBean
 */
export interface ListResponseSOVTemplateBean {
    /**
     * 
     * @type {Array<ItemResponseSOVTemplateBeanObject>}
     * @memberof ListResponseSOVTemplateBean
     */
    data?: Array<ItemResponseSOVTemplateBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSOVTemplateBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseScheduledReportRequestObject
 */
export interface ListResponseScheduledReportRequestObject {
    /**
     * 
     * @type {Array<ItemResponseScheduledReportRequestObjectObject>}
     * @memberof ListResponseScheduledReportRequestObject
     */
    data?: Array<ItemResponseScheduledReportRequestObjectObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseScheduledReportRequestObject
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface NodeBean
 */
export interface NodeBean {
    /**
     * 
     * @type {number}
     * @memberof NodeBean
     */
    id?: number;
    /**
     * Name of Node
     * @type {string}
     * @memberof NodeBean
     */
    name: string;
    /**
     * WalletId of Node
     * @type {string}
     * @memberof NodeBean
     */
    walletId: string;
    /**
     * ClusterId list of Node
     * @type {Array<string>}
     * @memberof NodeBean
     */
    clusterId: Array<string>;
    /**
     * IP address of Node
     * @type {string}
     * @memberof NodeBean
     */
    ip: string;
    /**
     * Port of Node
     * @type {number}
     * @memberof NodeBean
     */
    port: number;
    /**
     * Activity flag
     * @type {boolean}
     * @memberof NodeBean
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface PublisherBean
 */
export interface PublisherBean {
    /**
     * 
     * @type {number}
     * @memberof PublisherBean
     */
    id?: number;
    /**
     * Name of Publisher
     * @type {string}
     * @memberof PublisherBean
     */
    name: string;
    /**
     * Publisher email
     * @type {string}
     * @memberof PublisherBean
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherBean
     */
    language?: string;
    /**
     * Ids of Iab Categories
     * @type {Array<number>}
     * @memberof PublisherBean
     */
    iabCategoriesIds?: Array<number>;
    /**
     * Ids of excluded DSP
     * @type {Array<number>}
     * @memberof PublisherBean
     */
    dspBlackListIds?: Array<number>;
    /**
     * Id of the Group
     * @type {number}
     * @memberof PublisherBean
     */
    publisherGroupId?: number;
    /**
     * List of Domains. Working as a black list when blackListDomains is true and as a white list when vice versa
     * @type {Array<string>}
     * @memberof PublisherBean
     */
    domains?: Array<string>;
    /**
     * Domains filter mode.
     * @type {boolean}
     * @memberof PublisherBean
     */
    blackListDomains?: boolean;
    /**
     * Token for authorize Publisher on exchange
     * @type {string}
     * @memberof PublisherBean
     */
    token?: string;
    /**
     * Auction type, where 1 = First Price, 2 = Second Price Plus. Exchange-specific auction types can be defined using values greater than 500
     * @type {string}
     * @memberof PublisherBean
     */
    auctionMode: PublisherBean.AuctionModeEnum;
    /**
     * House Bidder Mode
     * @type {string}
     * @memberof PublisherBean
     */
    houseBidderMode: PublisherBean.HouseBidderModeEnum;
    /**
     * Maximum queries per second allowed
     * @type {number}
     * @memberof PublisherBean
     */
    maxQps?: number;
    /**
     * 
     * @type {AuthDataBean}
     * @memberof PublisherBean
     */
    authDataBean?: AuthDataBean;
    /**
     * Activity flag
     * @type {boolean}
     * @memberof PublisherBean
     */
    active: boolean;
    /**
     * Validation request flag
     * @type {boolean}
     * @memberof PublisherBean
     */
    validation: boolean;
    /**
     * Publisher fee
     * @type {number}
     * @memberof PublisherBean
     */
    fee: number;
    /**
     * Public validation key
     * @type {string}
     * @memberof PublisherBean
     */
    publicValidationKey?: string;
    /**
     * Seller account id
     * @type {number}
     * @memberof PublisherBean
     */
    sellerAccountId?: number;
    /**
     * Publisher timezoneId
     * @type {string}
     * @memberof PublisherBean
     */
    timezoneId?: string;
    /**
     * Publisher test flag
     * @type {boolean}
     * @memberof PublisherBean
     */
    test?: boolean;
    /**
     * Limit of period for Athena reports
     * @type {number}
     * @memberof PublisherBean
     */
    athenaPeriodLimit?: number;
    /**
     * Remaining period limit for Athena reports in the current period
     * @type {number}
     * @memberof PublisherBean
     */
    athenaPeriodLeft?: number;
    /**
     * Limit the number of validation report
     * @type {number}
     * @memberof PublisherBean
     */
    athenaValidationsLimit?: number;
    /**
     * Remaining number of verification reports in the current period
     * @type {number}
     * @memberof PublisherBean
     */
    athenaValidationsLeft?: number;
    /**
     * Limit validity month
     * @type {number}
     * @memberof PublisherBean
     */
    reportLimitsMonth?: number;
    /**
     * Publisher's App bundle
     * @type {string}
     * @memberof PublisherBean
     */
      bundle?: string;
      /**
       * Publisher's App store URL
       * @type {string}
       * @memberof PublisherBean
       */
      storeUrl?: string;
      /**
       * Publisher's domain
       * @type {string}
       * @memberof PublisherBean
       */
      publisherDomain?: string;
}

/**
 * @export
 * @namespace PublisherBean
 */
export namespace PublisherBean {
    /**
     * @export
     * @enum {string}
     */
    export enum AuctionModeEnum {
        FirstPrice = <any> 'FirstPrice',
        SecondPrice = <any> 'SecondPrice'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum HouseBidderModeEnum {
        Off = <any> 'Off',
        HouseCreatives = <any> 'HouseCreatives',
        EmptyPlaceholders = <any> 'EmptyPlaceholders'
    }
}
/**
 * 
 * @export
 * @interface PublisherDashboardReportRequestParameters
 */
export interface PublisherDashboardReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<PublisherReportKeyColumnDescription>}
     * @memberof PublisherDashboardReportRequestParameters
     */
    keyColumns?: Array<PublisherReportKeyColumnDescription>;
    /**
     * 
     * @type {Array<PublisherDashboardReportValueColumnDescription>}
     * @memberof PublisherDashboardReportRequestParameters
     */
    valueColumns?: Array<PublisherDashboardReportValueColumnDescription>;
}

/**
 * @export
 * @namespace PublisherDashboardReportRequestParameters
 */
export namespace PublisherDashboardReportRequestParameters {
}
/**
 * 
 * @export
 * @interface PublisherDashboardReportValueColumnDescription
 */
export interface PublisherDashboardReportValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof PublisherDashboardReportValueColumnDescription
     */
    column?: PublisherDashboardReportValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof PublisherDashboardReportValueColumnDescription
     */
    order?: PublisherDashboardReportValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherDashboardReportValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof PublisherDashboardReportValueColumnDescription
     */
    where?: ValueFilterClause;
}

/**
 * @export
 * @namespace PublisherDashboardReportValueColumnDescription
 */
export namespace PublisherDashboardReportValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        AdRequests = <any> 'AdRequests',
        AdResponses = <any> 'AdResponses',
        FillRate = <any> 'FillRate',
        WinThroughRate = <any> 'WinThroughRate',
        ECPM = <any> 'ECPM',
        WinImpressions = <any> 'WinImpressions',
        PublisherRevenue = <any> 'PublisherRevenue'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface PublisherGroupBean
 */
export interface PublisherGroupBean {
    /**
     * 
     * @type {number}
     * @memberof PublisherGroupBean
     */
    id?: number;
    /**
     * Name of Publisher Group
     * @type {string}
     * @memberof PublisherGroupBean
     */
    name: string;
    /**
     * Name of Publisher Group
     * @type {string}
     * @memberof PublisherGroupBean
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface PublisherReportKeyColumnDescription
 */
export interface PublisherReportKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof PublisherReportKeyColumnDescription
     */
    column?: PublisherReportKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof PublisherReportKeyColumnDescription
     */
    order?: PublisherReportKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherReportKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof PublisherReportKeyColumnDescription
     */
    where?: KeyFilterClause;
}

/**
 * @export
 * @namespace PublisherReportKeyColumnDescription
 */
export namespace PublisherReportKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Publisher = <any> 'Publisher',
        PublisherId = <any> 'PublisherId',
        Dsp = <any> 'Dsp',
        DspId = <any> 'DspId',
        Date = <any> 'Date',
        FourHourly = <any> 'FourHourly',
        Daily = <any> 'Daily',
        Weekly = <any> 'Weekly',
        Monthly = <any> 'Monthly',
        Yearly = <any> 'Yearly',
        Size = <any> 'Size',
        MediaType = <any> 'MediaType',
        Domain = <any> 'Domain',
        MobileAppId = <any> 'MobileAppId',
        DeviceType = <any> 'DeviceType',
        Country = <any> 'Country',
        Deal = <any> 'Deal'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface PublisherReportRequestParameters
 */
export interface PublisherReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<PublisherReportKeyColumnDescription>}
     * @memberof PublisherReportRequestParameters
     */
    keyColumns?: Array<PublisherReportKeyColumnDescription>;
    /**
     * 
     * @type {Array<PublisherReportValueColumnDescription>}
     * @memberof PublisherReportRequestParameters
     */
    valueColumns?: Array<PublisherReportValueColumnDescription>;
}

/**
 * @export
 * @namespace PublisherReportRequestParameters
 */
export namespace PublisherReportRequestParameters {
}
/**
 * 
 * @export
 * @interface PublisherReportValueColumnDescription
 */
export interface PublisherReportValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof PublisherReportValueColumnDescription
     */
    column?: PublisherReportValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof PublisherReportValueColumnDescription
     */
    order?: PublisherReportValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherReportValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof PublisherReportValueColumnDescription
     */
    where?: ValueFilterClause;
}

/**
 * @export
 * @namespace PublisherReportValueColumnDescription
 */
export namespace PublisherReportValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Requests = <any> 'Requests',
        AdSlotRequests = <any> 'AdSlotRequests',
        Bids = <any> 'Bids',
        Wins = <any> 'Wins',
        WinRate = <any> 'WinRate',
        PageImpressions = <any> 'PageImpressions',
        Impressions = <any> 'Impressions',
        PublisherRevenue = <any> 'PublisherRevenue',
        RevenueWin = <any> 'RevenueWin',
        RevenueImpr = <any> 'RevenueImpr',
        AvgBidFloor = <any> 'AvgBidFloor',
        AvgLowestBidPrice = <any> 'AvgLowestBidPrice',
        AvgMedianBidPrice = <any> 'AvgMedianBidPrice',
        AvgHighestBidPrice = <any> 'AvgHighestBidPrice',
        EffectiveBid = <any> 'EffectiveBid',
        View = <any> 'View',
        Click = <any> 'Click',
        VastStart = <any> 'VastStart',
        VastFirstQ = <any> 'VastFirstQ',
        VastMidpoint = <any> 'VastMidpoint',
        VastThirdQ = <any> 'VastThirdQ',
        VastComplete = <any> 'VastComplete',
        VastError = <any> 'VastError',
        FillRate = <any> 'FillRate',
        WinThroughRate = <any> 'WinThroughRate',
        ECPMWin = <any> 'ECPMWin',
        ECPMImpr = <any> 'ECPMImpr',
        BidFloor = <any> 'BidFloor',
        LowestBidPrice = <any> 'LowestBidPrice',
        MedianBidPrice = <any> 'MedianBidPrice',
        HighestBidPrice = <any> 'HighestBidPrice',
        DspWinPrice = <any> 'DspWinPrice',
        FPARequests = <any> 'FPARequests',
        FPAAdSlotRequests = <any> 'FPAAdSlotRequests',
        FPAWins = <any> 'FPAWins',
        FPAImpressions = <any> 'FPAImpressions',
        FPAAdditionalImpressions = <any> 'FPAAdditionalImpressions',
        FPAFullPageImpressions = <any> 'FPAFullPageImpressions',
        DspImprPrice = <any> 'DspImprPrice',
        AlkimiCommissionWin = <any> 'AlkimiCommissionWin',
        AlkimiCommissionImpr = <any> 'AlkimiCommissionImpr',
        AlkimiCommission = <any> 'AlkimiCommission',
        NetRevenueWin = <any> 'NetRevenueWin',
        NetRevenueImpr = <any> 'NetRevenueImpr',
        NetPublisherRevenue = <any> 'NetPublisherRevenue',
        DspFee = <any> 'DspFee',
        DspFeeWin = <any> 'DspFeeWin',
        DspFeeImpr = <any> 'DspFeeImpr',
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface RawReportKeyColumnDescription
 */
export interface RawReportKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof RawReportKeyColumnDescription
     */
    column?: RawReportKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof RawReportKeyColumnDescription
     */
    order?: RawReportKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RawReportKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof RawReportKeyColumnDescription
     */
    where?: KeyFilterClause;
}

/**
 * @export
 * @namespace RawReportKeyColumnDescription
 */
export namespace RawReportKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        ImpIdGroup = <any> 'ImpIdGroup',
        PublisherIdGroup = <any> 'PublisherIdGroup',
        RequestIdGroup = <any> 'RequestIdGroup',
        TimestampGroup = <any> 'TimestampGroup',
        ValidationPathGroup = <any> 'ValidationPathGroup',
        ValidationDspIdGroup = <any> 'ValidationDspIdGroup',
        ValidationBidRequestIdGroup = <any> 'ValidationBidRequestIdGroup',
        ValidationResponseIdGroup = <any> 'ValidationResponseIdGroup',
        ValidationDspId = <any> 'ValidationDspId',
        Timestamp = <any> 'Timestamp',
        MinTimestamp = <any> 'MinTimestamp',
        RequestId = <any> 'RequestId',
        PublisherId = <any> 'PublisherId',
        BidId = <any> 'BidId',
        ImpId = <any> 'ImpId',
        PrebidRequest = <any> 'PrebidRequest',
        PrebidResponse = <any> 'PrebidResponse',
        Audio = <any> 'Audio',
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        Ip = <any> 'Ip',
        UserAgent = <any> 'UserAgent',
        PrebidReq = <any> 'PrebidReq',
        PrebidBid = <any> 'PrebidBid',
        PrebidWin = <any> 'PrebidWin',
        PrebidImpr = <any> 'PrebidImpr',
        PrebidBidFloor = <any> 'PrebidBidFloor',
        PrebidBidPrice = <any> 'PrebidBidPrice',
        DspId = <any> 'DspId',
        DspRequest = <any> 'DspRequest',
        DspResponse = <any> 'DspResponse',
        DspReq = <any> 'DspReq',
        DspBid = <any> 'DspBid',
        DspWin = <any> 'DspWin',
        DspImpr = <any> 'DspImpr',
        DspImprPrice = <any> 'DspImprPrice',
        DspWinPrice = <any> 'DspWinPrice',
        DspBidPrice = <any> 'DspBidPrice'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface RawReportRequestParameters
 */
export interface RawReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<RawReportKeyColumnDescription>}
     * @memberof RawReportRequestParameters
     */
    keyColumns?: Array<RawReportKeyColumnDescription>;
    /**
     * 
     * @type {Array<RawReportValueColumnDescription>}
     * @memberof RawReportRequestParameters
     */
    valueColumns?: Array<RawReportValueColumnDescription>;
    /**
     * 
     * @type {string}
     * @memberof RawReportRequestParameters
     */
    reportType?: RawReportRequestParameters.ReportTypeEnum;
}

/**
 * @export
 * @namespace RawReportRequestParameters
 */
export namespace RawReportRequestParameters {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
}
/**
 * 
 * @export
 * @interface RawReportValueColumnDescription
 */
export interface RawReportValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof RawReportValueColumnDescription
     */
    column?: RawReportValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof RawReportValueColumnDescription
     */
    order?: RawReportValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RawReportValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof RawReportValueColumnDescription
     */
    where?: ValueFilterClause;
}

/**
 * @export
 * @namespace RawReportValueColumnDescription
 */
export namespace RawReportValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        BidId = <any> 'BidId',
        PrebidRequest = <any> 'PrebidRequest',
        PrebidResponse = <any> 'PrebidResponse',
        Audio = <any> 'Audio',
        Video = <any> 'Video',
        Banner = <any> 'Banner',
        PrebidBidFloor = <any> 'PrebidBidFloor',
        PrebidBidPrice = <any> 'PrebidBidPrice',
        DspsBids = <any> 'DspsBids'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface ReportBean
 */
export interface ReportBean {
    /**
     * 
     * @type {number}
     * @memberof ReportBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportBean
     */
    error?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReportBean
     */
    totalValues?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface ReportRequestParametersObjectObject
 */
export interface ReportRequestParametersObjectObject {
    /**
     * 
     * @type {string}
     * @memberof ReportRequestParametersObjectObject
     */
    type?: ReportRequestParametersObjectObject.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestParametersObjectObject
     */
    timezone?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReportRequestParametersObjectObject
     */
    valueColumns?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReportRequestParametersObjectObject
     */
    keyColumns?: Array<any>;
}

/**
 * @export
 * @namespace ReportRequestParametersObjectObject
 */
export namespace ReportRequestParametersObjectObject {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
}
/**
 * 
 * @export
 * @interface ReportTemplateRequest
 */
export interface ReportTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequest
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportTemplateRequest
     */
    active?: boolean;
    /**
     * 
     * @type {DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters}
     * @memberof ReportTemplateRequest
     */
    requestParameters?: DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequest
     */
    reportType?: ReportTemplateRequest.ReportTypeEnum;
}

/**
 * @export
 * @namespace ReportTemplateRequest
 */
export namespace ReportTemplateRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
}
/**
 * 
 * @export
 * @interface ReportTemplateRequestObject
 */
export interface ReportTemplateRequestObject {
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequestObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequestObject
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequestObject
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportTemplateRequestObject
     */
    active?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ReportTemplateRequestObject
     */
    requestParameters?: any;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequestObject
     */
    reportType?: ReportTemplateRequestObject.ReportTypeEnum;
}

/**
 * @export
 * @namespace ReportTemplateRequestObject
 */
export namespace ReportTemplateRequestObject {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
}
/**
 * 
 * @export
 * @interface ReportTemplateRequestReportRequestParametersObjectObject
 */
export interface ReportTemplateRequestReportRequestParametersObjectObject {
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    active?: boolean;
    /**
     * 
     * @type {DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    requestParameters?: DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters;
    /**
     * 
     * @type {string}
     * @memberof ReportTemplateRequestReportRequestParametersObjectObject
     */
    reportType?: ReportTemplateRequestReportRequestParametersObjectObject.ReportTypeEnum;
}

/**
 * @export
 * @namespace ReportTemplateRequestReportRequestParametersObjectObject
 */
export namespace ReportTemplateRequestReportRequestParametersObjectObject {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
}
/**
 * 
 * @export
 * @interface SOVTemplateBean
 */
export interface SOVTemplateBean {
    /**
     * 
     * @type {number}
     * @memberof SOVTemplateBean
     */
    id?: number;
    /**
     * Name of SOV Template
     * @type {string}
     * @memberof SOVTemplateBean
     */
    name: string;
    /**
     * Publisher required
     * @type {number}
     * @memberof SOVTemplateBean
     */
    publisherId: number;
    /**
     * Activity flag
     * @type {boolean}
     * @memberof SOVTemplateBean
     */
    active: boolean;
    /**
     * URL pattern required
     * @type {string}
     * @memberof SOVTemplateBean
     */
    urlPattern: string;
    /**
     * Ad Size list of this template
     * @type {string}
     * @memberof SOVTemplateBean
     */
    adSizeList: string;
    /**
     * Number of ads
     * @type {number}
     * @memberof SOVTemplateBean
     */
    numberOfAds?: number;
}
/**
 * 
 * @export
 * @interface ScheduledReportRequest
 */
export interface ScheduledReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequest
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledReportRequest
     */
    active?: boolean;
    /**
     * 
     * @type {DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters}
     * @memberof ScheduledReportRequest
     */
    requestParameters?: DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    frequency?: ScheduledReportRequest.FrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    reportType?: ScheduledReportRequest.ReportTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledReportRequest
     */
    nextReport?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    lastReport?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    lastReportDates?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequest
     */
    status?: ScheduledReportRequest.StatusEnum;
}

/**
 * @export
 * @namespace ScheduledReportRequest
 */
export namespace ScheduledReportRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum FrequencyEnum {
        Daily = <any> 'Daily',
        Weekly = <any> 'Weekly',
        Monthly = <any> 'Monthly'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        New = <any> 'New',
        Processing = <any> 'Processing',
        Error = <any> 'Error',
        Success = <any> 'Success',
        EmailMissing = <any> 'EmailMissing',
        FailToSendEmail = <any> 'FailToSendEmail'
    }
}
/**
 * 
 * @export
 * @interface ScheduledReportRequestObject
 */
export interface ScheduledReportRequestObject {
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequestObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequestObject
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledReportRequestObject
     */
    active?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ScheduledReportRequestObject
     */
    requestParameters?: any;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    frequency?: ScheduledReportRequestObject.FrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    reportType?: ScheduledReportRequestObject.ReportTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledReportRequestObject
     */
    nextReport?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    lastReport?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    lastReportDates?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestObject
     */
    status?: ScheduledReportRequestObject.StatusEnum;
}

/**
 * @export
 * @namespace ScheduledReportRequestObject
 */
export namespace ScheduledReportRequestObject {
    /**
     * @export
     * @enum {string}
     */
    export enum FrequencyEnum {
        Daily = <any> 'Daily',
        Weekly = <any> 'Weekly',
        Monthly = <any> 'Monthly'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        New = <any> 'New',
        Processing = <any> 'Processing',
        Error = <any> 'Error',
        Success = <any> 'Success',
        EmailMissing = <any> 'EmailMissing',
        FailToSendEmail = <any> 'FailToSendEmail'
    }
}
/**
 * 
 * @export
 * @interface ScheduledReportRequestReportRequestParametersObjectObject
 */
export interface ScheduledReportRequestReportRequestParametersObjectObject {
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    account?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    active?: boolean;
    /**
     * 
     * @type {DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    requestParameters?: DspReportRequestParameters | PublisherDashboardReportRequestParameters | PublisherReportRequestParameters | RawReportRequestParameters;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    frequency?: ScheduledReportRequestReportRequestParametersObjectObject.FrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    reportType?: ScheduledReportRequestReportRequestParametersObjectObject.ReportTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    nextReport?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    lastReport?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    lastReportDates?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledReportRequestReportRequestParametersObjectObject
     */
    status?: ScheduledReportRequestReportRequestParametersObjectObject.StatusEnum;
}

/**
 * @export
 * @namespace ScheduledReportRequestReportRequestParametersObjectObject
 */
export namespace ScheduledReportRequestReportRequestParametersObjectObject {
    /**
     * @export
     * @enum {string}
     */
    export enum FrequencyEnum {
        Daily = <any> 'Daily',
        Weekly = <any> 'Weekly',
        Monthly = <any> 'Monthly'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        ByPublisher = <any> 'ByPublisher',
        ByDsp = <any> 'ByDsp',
        Raw = <any> 'Raw',
        RequestIds = <any> 'RequestIds',
        ResponseIds = <any> 'ResponseIds',
        PublisherDashboard = <any> 'PublisherDashboard'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        New = <any> 'New',
        Processing = <any> 'Processing',
        Error = <any> 'Error',
        Success = <any> 'Success',
        EmailMissing = <any> 'EmailMissing',
        FailToSendEmail = <any> 'FailToSendEmail'
    }
}
/**
 * 
 * @export
 * @interface TimeZoneBean
 */
export interface TimeZoneBean {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeZoneBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TimeZoneBean
     */
    rawOffset?: number;
}
/**
 * 
 * @export
 * @interface ValidationRequest
 */
export interface ValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    id1?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    id2?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    transactionType?: ValidationRequest.TransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    hash?: string;
    /**
     * 
     * @type {Date}
     * @memberof ValidationRequest
     */
    dateTime?: Date;
}

/**
 * @export
 * @namespace ValidationRequest
 */
export namespace ValidationRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum TransactionTypeEnum {
        BidRequest = <any> 'BidRequest',
        BidResponse = <any> 'BidResponse',
        Win = <any> 'Win',
        Impression = <any> 'Impression'
    }
}
/**
 * 
 * @export
 * @interface ValueFilterClause
 */
export interface ValueFilterClause {
    /**
     * 
     * @type {string}
     * @memberof ValueFilterClause
     */
    type?: ValueFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof ValueFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace ValueFilterClause
 */
export namespace ValueFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Le = <any> 'le',
        Ge = <any> 'ge',
        Between = <any> 'between'
    }
}
/**
 * AccountControllerApi - fetch parameter creator
 * @export
 */
export const AccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling account.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj?.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user properties by sign in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options: any = {}): FetchArgs {
            const localVarPath = `/api/accountProps`;
            const headersX=document.cookie.split("=");
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers,{[headersX[0]]:headersX[1]});

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options: any = {}): FetchArgs {
            const localVarPath = `/api/account`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAccount.');
            }
            const localVarPath = `/api/account`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit Account by id
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccount.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).account(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user properties by sign in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accountProps(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAccountBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accounts(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).createAccount(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).deleteAccount(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Edit Account by id
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).editAccount(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any) {
            return AccountControllerApiFp(configuration).account(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user properties by sign in account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any) {
            return AccountControllerApiFp(configuration).accountProps(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any) {
            return AccountControllerApiFp(configuration).accounts(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Account
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any) {
            return AccountControllerApiFp(configuration).createAccount(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Account by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any) {
            return AccountControllerApiFp(configuration).deleteAccount(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Edit Account by id
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any) {
            return AccountControllerApiFp(configuration).editAccount(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Account by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public account(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).account(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user properties by sign in account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accountProps(options?: any) {
        return AccountControllerApiFp(this.configuration).accountProps(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accounts(options?: any) {
        return AccountControllerApiFp(this.configuration).accounts(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Account
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public createAccount(body: AccountBean, options?: any) {
        return AccountControllerApiFp(this.configuration).createAccount(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Account by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public deleteAccount(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).deleteAccount(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Edit Account by id
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public editAccount(body: AccountBean, id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).editAccount(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * DealControllerApi - fetch parameter creator
 * @export
 */
export const DealControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Deal
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createDeal.');
            }
            const localVarPath = `/api/deal`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DealBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealTypesList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/deal-types`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealStatusList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/deal-status`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
           deviceTypeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/device-types`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
          mediaTypeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/media-types`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }, 
        adSizesList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/house-ad-sizes`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        
        /**
         * 
         * @summary Delete Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDeal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Deal by id
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editDeal.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editDeal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DealBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DealControllerApi - functional programming interface
 * @export
 */
export const DealControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Deal
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).createDeal(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).deal(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealTypesList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealTypesList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealStatusList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealStatusList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
          deviceTypeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).deviceTypeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
          mediaTypeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).mediaTypeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
         adSizesList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).adSizesList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).deleteDeal(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Deal by id
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).editDeal(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DealControllerApi - factory interface
 * @export
 */
export const DealControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new Deal
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options?: any) {
            return DealControllerApiFp(configuration).createDeal(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options?: any) {
            return DealControllerApiFp(configuration).deal(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).dealList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealTypesList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).dealTypesList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Deals
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealStatusList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).dealStatusList(search, options)(fetch, basePath);
        },
         deviceTypeList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).deviceTypeList(search, options)(fetch, basePath);
        },
         mediaTypeList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).mediaTypeList(search, options)(fetch, basePath);
        },
         adSizesList(search?: string, options?: any) {
            return DealControllerApiFp(configuration).adSizesList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Deal by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options?: any) {
            return DealControllerApiFp(configuration).deleteDeal(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Deal by id
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options?: any) {
            return DealControllerApiFp(configuration).editDeal(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * DealControllerApi - object-oriented interface
 * @export
 * @class DealControllerApi
 * @extends {BaseAPI}
 */
export class DealControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Deal
     * @param {DealBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public createDeal(body: DealBean, options?: any) {
        return DealControllerApiFp(this.configuration).createDeal(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Deal by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public deal(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).deal(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Deals
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).dealList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Deals
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealTypesList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).dealTypesList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Deals
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    
    public dealStatusList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).dealStatusList(search, options)(this.fetch, this.basePath);
    }
    public deviceTypeList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).deviceTypeList(search, options)(this.fetch, this.basePath);
    }
    public mediaTypeList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).mediaTypeList(search, options)(this.fetch, this.basePath);
    }
    public adSizesList(search?: string, options?: any) {
        return DealControllerApiFp(this.configuration).adSizesList(search, options)(this.fetch, this.basePath);
    }
    /**
     * 
     * @summary Delete Deal by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public deleteDeal(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).deleteDeal(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Deal by id
     * @param {DealBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public editDeal(body: DealBean, id: number, options?: any) {
        return DealControllerApiFp(this.configuration).editDeal(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * DictionariesControllerApi - fetch parameter creator
 * @export
 */
export const DictionariesControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get List of iab categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options: any = {}): FetchArgs {
            const localVarPath = `/api/iab-category`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List of countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options: any = {}): FetchArgs {
            const localVarPath = `/api/countries`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );

            // fix override query string
            delete localVarUrlObj.search;

            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         * 
         * @summary Get List of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options: any = {}): FetchArgs {
            const localVarPath = `/api/language`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         * 
         * @summary Get List of countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options: any = {}): FetchArgs {
            const localVarPath = `/api/countries`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );

            // fix override query string
            delete localVarUrlObj.search;

            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },


        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options: any = {}): FetchArgs {
            const localVarPath = `/api/timezone`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deviceType(options: any = {}): FetchArgs {
            const localVarPath = `/api/device-type`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        os(options: any = {}): FetchArgs {
            const localVarPath = `/api/os`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesControllerApi - functional programming interface
 * @export
 */
export const DictionariesControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get List of iab categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<IabCategoryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).iabCategories(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        countries(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CountryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).countries(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get List of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LanguageBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).language(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        countries(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CountryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).countries(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TimeZoneBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).timezone(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        deviceType(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).deviceType(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        os(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).os(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DictionariesControllerApi - factory interface
 * @export
 */
export const DictionariesControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get List of iab categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any) {
            return DictionariesControllerApiFp(configuration).countries(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get List of iab categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any) {
            return DictionariesControllerApiFp(configuration).iabCategories(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get List of iab categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any) {
            return DictionariesControllerApiFp(configuration).countries(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get List of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any) {
            return DictionariesControllerApiFp(configuration).language(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any) {
            return DictionariesControllerApiFp(configuration).timezone(options)(fetch, basePath);
        },
        deviceType(options?: any) {
            return DictionariesControllerApiFp(configuration).deviceType(options)(fetch, basePath);
        },
        os(options?: any) {
            return DictionariesControllerApiFp(configuration).os(options)(fetch, basePath);
        },
    };
};

/**
 * DictionariesControllerApi - object-oriented interface
 * @export
 * @class DictionariesControllerApi
 * @extends {BaseAPI}
 */
export class DictionariesControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get List of countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public iabCategories(options?: any) {
        return DictionariesControllerApiFp(this.configuration).iabCategories(options)(this.fetch, this.basePath);
    }


    /**
     * 
     * @summary Get List of countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public countries(options?: any) {
        return DictionariesControllerApiFp(this.configuration).countries(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get List of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public language(options?: any) {
        return DictionariesControllerApiFp(this.configuration).language(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public timezone(options?: any) {
        return DictionariesControllerApiFp(this.configuration).timezone(options)(this.fetch, this.basePath);
    }
    public deviceType(options?: any) {
        return DictionariesControllerApiFp(this.configuration).deviceType(options)(this.fetch, this.basePath);
    }
    public os(options?: any) {
        return DictionariesControllerApiFp(this.configuration).os(options)(this.fetch, this.basePath);
    }
    /**
     * 
     * @summary Get List of countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public countries(options?: any) {
        return DictionariesControllerApiFp(this.configuration).countries(options)(this.fetch, this.basePath);
    }


}
/**
 * DspControllerApi - fetch parameter creator
 * @export
 */
export const DspControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/all-dsp`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Dsp
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createDsp.');
            }
            const localVarPath = `/api/dsp`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling dsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/dsp`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Dsp by id
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editDsp.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editDsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Mini Exchanges
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miniExchangeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/mini-exchange`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        clustersList(options: any = {}): FetchArgs {
            const localVarPath = `/api/dsp/cluster`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DspControllerApi - functional programming interface
 * @export
 */
export const DspControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDspBean> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).all(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new Dsp
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).createDsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).deleteDsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).dsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDspBean> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).dspList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Dsp by id
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).editDsp(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Mini Exchanges
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miniExchangeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDspBean> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).miniExchangeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        clustersList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ClusterKeyValue>> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).clustersList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DspControllerApi - factory interface
 * @export
 */
export const DspControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all(search?: string, options?: any) {
            return DspControllerApiFp(configuration).all(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new Dsp
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options?: any) {
            return DspControllerApiFp(configuration).createDsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options?: any) {
            return DspControllerApiFp(configuration).deleteDsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Dsp by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options?: any) {
            return DspControllerApiFp(configuration).dsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Dsps
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(search?: string, options?: any) {
            return DspControllerApiFp(configuration).dspList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Dsp by id
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options?: any) {
            return DspControllerApiFp(configuration).editDsp(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Mini Exchanges
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        miniExchangeList(search?: string, options?: any) {
            return DspControllerApiFp(configuration).miniExchangeList(search, options)(fetch, basePath);
        },
        clustersList(options?: any) {
            return DspControllerApiFp(configuration).clustersList(options)(fetch, basePath);
        },
    };
};

/**
 * DspControllerApi - object-oriented interface
 * @export
 * @class DspControllerApi
 * @extends {BaseAPI}
 */
export class DspControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get all Dsps
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public all(search?: string, options?: any) {
        return DspControllerApiFp(this.configuration).all(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new Dsp
     * @param {DspBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public createDsp(body: DspBean, options?: any) {
        return DspControllerApiFp(this.configuration).createDsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Dsp by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public deleteDsp(id: number, options?: any) {
        return DspControllerApiFp(this.configuration).deleteDsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Dsp by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public dsp(id: number, options?: any) {
        return DspControllerApiFp(this.configuration).dsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Dsps
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public dspList(search?: string, options?: any) {
        return DspControllerApiFp(this.configuration).dspList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Dsp by id
     * @param {DspBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public editDsp(body: DspBean, id: number, options?: any) {
        return DspControllerApiFp(this.configuration).editDsp(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Mini Exchanges
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public miniExchangeList(search?: string, options?: any) {
        return DspControllerApiFp(this.configuration).miniExchangeList(search, options)(this.fetch, this.basePath);
    }

    public clustersList(options?: any) {
        return DspControllerApiFp(this.configuration).clustersList(options)(this.fetch, this.basePath);
    }

}
/**
 * HouseAdSizeControllerApi - fetch parameter creator
 * @export
 */
export const HouseAdSizeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adSize.');
            }
            const localVarPath = `/api/house-ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all House Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/house-ad-size`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new House Ad Size
         * @param {HouseAdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: HouseAdSizeBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdSize.');
            }
            const localVarPath = `/api/house-ad-size`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HouseAdSizeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdSize.');
            }
            const localVarPath = `/api/house-ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update House Ad Size by id
         * @param {HouseAdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: HouseAdSizeBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdSize.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdSize.');
            }
            const localVarPath = `/api/house-ad-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HouseAdSizeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HouseAdSizeControllerApi - functional programming interface
 * @export
 */
export const HouseAdSizeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseAdSizeBeanObject> {
            const localVarFetchArgs = HouseAdSizeControllerApiFetchParamCreator(configuration).adSize(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all House Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseHouseAdSizeBean> {
            const localVarFetchArgs = HouseAdSizeControllerApiFetchParamCreator(configuration).adSizeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new House Ad Size
         * @param {HouseAdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: HouseAdSizeBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseAdSizeBeanObject> {
            const localVarFetchArgs = HouseAdSizeControllerApiFetchParamCreator(configuration).createAdSize(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = HouseAdSizeControllerApiFetchParamCreator(configuration).deleteAdSize(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update House Ad Size by id
         * @param {HouseAdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: HouseAdSizeBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseAdSizeBeanObject> {
            const localVarFetchArgs = HouseAdSizeControllerApiFetchParamCreator(configuration).editAdSize(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * HouseAdSizeControllerApi - factory interface
 * @export
 */
export const HouseAdSizeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSize(id: number, options?: any) {
            return HouseAdSizeControllerApiFp(configuration).adSize(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all House Ad Sizes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adSizeList(search?: string, options?: any) {
            return HouseAdSizeControllerApiFp(configuration).adSizeList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new House Ad Size
         * @param {HouseAdSizeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdSize(body: HouseAdSizeBean, options?: any) {
            return HouseAdSizeControllerApiFp(configuration).createAdSize(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete House Ad Size by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdSize(id: number, options?: any) {
            return HouseAdSizeControllerApiFp(configuration).deleteAdSize(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update House Ad Size by id
         * @param {HouseAdSizeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdSize(body: HouseAdSizeBean, id: number, options?: any) {
            return HouseAdSizeControllerApiFp(configuration).editAdSize(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * HouseAdSizeControllerApi - object-oriented interface
 * @export
 * @class HouseAdSizeControllerApi
 * @extends {BaseAPI}
 */
export class HouseAdSizeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get House Ad Size by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseAdSizeControllerApi
     */
    public adSize(id: number, options?: any) {
        return HouseAdSizeControllerApiFp(this.configuration).adSize(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all House Ad Sizes
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseAdSizeControllerApi
     */
    public adSizeList(search?: string, options?: any) {
        return HouseAdSizeControllerApiFp(this.configuration).adSizeList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new House Ad Size
     * @param {HouseAdSizeBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseAdSizeControllerApi
     */
    public createAdSize(body: HouseAdSizeBean, options?: any) {
        return HouseAdSizeControllerApiFp(this.configuration).createAdSize(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete House Ad Size by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseAdSizeControllerApi
     */
    public deleteAdSize(id: number, options?: any) {
        return HouseAdSizeControllerApiFp(this.configuration).deleteAdSize(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update House Ad Size by id
     * @param {HouseAdSizeBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseAdSizeControllerApi
     */
    public editAdSize(body: HouseAdSizeBean, id: number, options?: any) {
        return HouseAdSizeControllerApiFp(this.configuration).editAdSize(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * HouseCreativeControllerApi - fetch parameter creator
 * @export
 */
export const HouseCreativeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new House Creative
         * @param {HouseCreativeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(body: HouseCreativeBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCreative.');
            }
            const localVarPath = `/api/house-creative`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HouseCreativeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling creative.');
            }
            const localVarPath = `/api/house-creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all House Creatives
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/house-creative`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCreative.');
            }
            const localVarPath = `/api/house-creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update House Creative by id
         * @param {HouseCreativeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(body: HouseCreativeBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editCreative.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCreative.');
            }
            const localVarPath = `/api/house-creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HouseCreativeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HouseCreativeControllerApi - functional programming interface
 * @export
 */
export const HouseCreativeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new House Creative
         * @param {HouseCreativeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(body: HouseCreativeBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseCreativeBeanObject> {
            const localVarFetchArgs = HouseCreativeControllerApiFetchParamCreator(configuration).createCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseCreativeBeanObject> {
            const localVarFetchArgs = HouseCreativeControllerApiFetchParamCreator(configuration).creative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all House Creatives
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseHouseCreativeBean> {
            const localVarFetchArgs = HouseCreativeControllerApiFetchParamCreator(configuration).creativeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = HouseCreativeControllerApiFetchParamCreator(configuration).deleteCreative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update House Creative by id
         * @param {HouseCreativeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(body: HouseCreativeBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseHouseCreativeBeanObject> {
            const localVarFetchArgs = HouseCreativeControllerApiFetchParamCreator(configuration).editCreative(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * HouseCreativeControllerApi - factory interface
 * @export
 */
export const HouseCreativeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new House Creative
         * @param {HouseCreativeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(body: HouseCreativeBean, options?: any) {
            return HouseCreativeControllerApiFp(configuration).createCreative(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creative(id: number, options?: any) {
            return HouseCreativeControllerApiFp(configuration).creative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all House Creatives
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(search?: string, options?: any) {
            return HouseCreativeControllerApiFp(configuration).creativeList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete House Creative by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any) {
            return HouseCreativeControllerApiFp(configuration).deleteCreative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update House Creative by id
         * @param {HouseCreativeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(body: HouseCreativeBean, id: number, options?: any) {
            return HouseCreativeControllerApiFp(configuration).editCreative(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * HouseCreativeControllerApi - object-oriented interface
 * @export
 * @class HouseCreativeControllerApi
 * @extends {BaseAPI}
 */
export class HouseCreativeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new House Creative
     * @param {HouseCreativeBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseCreativeControllerApi
     */
    public createCreative(body: HouseCreativeBean, options?: any) {
        return HouseCreativeControllerApiFp(this.configuration).createCreative(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get House Creative by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseCreativeControllerApi
     */
    public creative(id: number, options?: any) {
        return HouseCreativeControllerApiFp(this.configuration).creative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all House Creatives
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseCreativeControllerApi
     */
    public creativeList(search?: string, options?: any) {
        return HouseCreativeControllerApiFp(this.configuration).creativeList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete House Creative by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseCreativeControllerApi
     */
    public deleteCreative(id: number, options?: any) {
        return HouseCreativeControllerApiFp(this.configuration).deleteCreative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update House Creative by id
     * @param {HouseCreativeBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HouseCreativeControllerApi
     */
    public editCreative(body: HouseCreativeBean, id: number, options?: any) {
        return HouseCreativeControllerApiFp(this.configuration).editCreative(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * NodeControllerApi - fetch parameter creator
 * @export
 */
export const NodeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Node
         * @param {NodeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNode(body: NodeBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createNode.');
            }
            const localVarPath = `/api/node`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NodeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNode.');
            }
            const localVarPath = `/api/node/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Node by id
         * @param {NodeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNode(body: NodeBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editNode.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editNode.');
            }
            const localVarPath = `/api/node/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NodeBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        node(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling node.');
            }
            const localVarPath = `/api/node/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Nodes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/node`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeControllerApi - functional programming interface
 * @export
 */
export const NodeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Node
         * @param {NodeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNode(body: NodeBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseNodeBeanObject> {
            const localVarFetchArgs = NodeControllerApiFetchParamCreator(configuration).createNode(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = NodeControllerApiFetchParamCreator(configuration).deleteNode(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Node by id
         * @param {NodeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNode(body: NodeBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseNodeBeanObject> {
            const localVarFetchArgs = NodeControllerApiFetchParamCreator(configuration).editNode(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        node(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseNodeBeanObject> {
            const localVarFetchArgs = NodeControllerApiFetchParamCreator(configuration).node(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Nodes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseNodeBean> {
            const localVarFetchArgs = NodeControllerApiFetchParamCreator(configuration).nodeList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * NodeControllerApi - factory interface
 * @export
 */
export const NodeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new Node
         * @param {NodeBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNode(body: NodeBean, options?: any) {
            return NodeControllerApiFp(configuration).createNode(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode(id: number, options?: any) {
            return NodeControllerApiFp(configuration).deleteNode(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Node by id
         * @param {NodeBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNode(body: NodeBean, id: number, options?: any) {
            return NodeControllerApiFp(configuration).editNode(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Node by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        node(id: number, options?: any) {
            return NodeControllerApiFp(configuration).node(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Nodes
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeList(search?: string, options?: any) {
            return NodeControllerApiFp(configuration).nodeList(search, options)(fetch, basePath);
        },
    };
};

/**
 * NodeControllerApi - object-oriented interface
 * @export
 * @class NodeControllerApi
 * @extends {BaseAPI}
 */
export class NodeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Node
     * @param {NodeBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeControllerApi
     */
    public createNode(body: NodeBean, options?: any) {
        return NodeControllerApiFp(this.configuration).createNode(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Node by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeControllerApi
     */
    public deleteNode(id: number, options?: any) {
        return NodeControllerApiFp(this.configuration).deleteNode(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Node by id
     * @param {NodeBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeControllerApi
     */
    public editNode(body: NodeBean, id: number, options?: any) {
        return NodeControllerApiFp(this.configuration).editNode(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Node by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeControllerApi
     */
    public node(id: number, options?: any) {
        return NodeControllerApiFp(this.configuration).node(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Nodes
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeControllerApi
     */
    public nodeList(search?: string, options?: any) {
        return NodeControllerApiFp(this.configuration).nodeList(search, options)(this.fetch, this.basePath);
    }

}
/**
 * PublisherControllerApi - fetch parameter creator
 * @export
 */
export const PublisherControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Publisher
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisher.');
            }
            const localVarPath = `/api/publisher`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePublisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Publisher by id
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editPublisher.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editPublisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Publishers Id and Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublishers(options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher/getAll`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Publisher Domains
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomains(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDomains.');
            }
            const localVarPath = `/api/publisher/domains`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
//
        // * @summary Download Text of Publisher by id
        // * @param {number} id 
        // * @param {*} [options] Override http request option.
        // * @throws {RequiredError}
        // *//
        
        downloadTxtFile(publisherId: number, options: any = {}): FetchArgs {
            if (publisherId === null || publisherId === undefined) {
                throw new RequiredError('publisherId', 'Required parameter publisherId was null or undefined when calling downloadTxtFile.');
            }
        
            const localVarPath = `/api/publisher/downloadTxtFile/{publisherId}`
                .replace(`{${"publisherId"}}`, encodeURIComponent(String(publisherId)));
        
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
        
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
        
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         *
         * @summary Download app-ads.txt file for Publisher
         * @param {number} publisherId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAppAdsTxtFile(publisherId: number, options: any = {}): FetchArgs {
            if (publisherId === null || publisherId === undefined) {
                throw new RequiredError('publisherId', 'Required parameter publisherId was null or undefined when calling downloadAppAdsTxtFile.');
            }

            const localVarPath = `/api/publisher/downloadAppAdsTxtFile/{publisherId}`
                .replace(`{${"publisherId"}}`, encodeURIComponent(String(publisherId)));

            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

///////////////////////////////


        /**
         *
         * @summary Get all Publishers
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Publishers for group
         * @param {number} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherListByGroup(groupId: number, options: any = {}): FetchArgs {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError('groupId','Required parameter groupId was null or undefined when calling publisherListByGroup.');
            }
            const localVarPath = `/api/publishers/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Publisher Transaction Start date
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionStartDate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling transactionStartDate.');
            }
            const localVarPath = `/api/publisher/transactionStartDate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update token by Publisher id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateToken.');
            }
            const localVarPath = `/api/publisher/{id}/token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activate Publisher by id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePublisher(id: number, options: any = {}): FetchArgs {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling activatePublisher.');
            }

            const localVarPath = `/api/publisher/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));

            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        /**
         * 
         * @summary Deactivate Publisher by id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePublisher(id: number, options: any = {}): FetchArgs {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deactivatePublisher.');
            }

            const localVarPath = `/api/publisher/deactivate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));

            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

    }
};

/**
 * PublisherControllerApi - functional programming interface
 * @export
 */
export const PublisherControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Publisher
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).createPublisher(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).deletePublisher(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Publisher by id
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).editPublisher(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get All Publishers Id and Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublishers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherBean> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).getAllPublishers(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Publisher Domains
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomains(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSetObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).getDomains(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisher(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },


        /////
        // * @summary Download Text for Publisher by id
        // * @param {number} id 
        // * @param {*} [options] Override http request option.
        // * @throws {RequiredError}

        downloadTxtFile(publisherId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).downloadTxtFile(publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options)
                    .then((response) => {
                        if (response.status >= 200 && response.status < 300) {
                            return response.text();
                        } else {
                            throw response;
                        }
                    });
            };
        },

        /**
         *
         * @summary Download app-ads.txt file for Publisher by id
         * @param {number} publisherId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAppAdsTxtFile(publisherId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).downloadAppAdsTxtFile(publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options)
                    .then((response) => {
                        if (response.status >= 200 && response.status < 300) {
                            return response.text();
                        } else {
                            throw response;
                        }
                    });
            };
        },





        ////////
        /**
         *
         * @summary Get all Publishers
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherBean> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisherList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Publishers for group
         * @param {number} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherListByGroup(groupId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherBean> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisherListByGroup(groupId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Publisher Transaction Start date
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionStartDate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).transactionStartDate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update token by Publisher id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).updateToken(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Activate Publisher by id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePublisher(id: number, options?: any):
        (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {

        const localVarFetchArgs =
            PublisherControllerApiFetchParamCreator(configuration).activatePublisher(id, options);

        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options)
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
        };
        },

        /**
        * 
        * @summary Deactivate Publisher by id
        * @param {number} id
        * @param {*} [options] Override http request option.
        * @throws {RequiredError}
        */
        deactivatePublisher(id: number, options?: any):
        (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {

        const localVarFetchArgs =
            PublisherControllerApiFetchParamCreator(configuration).deactivatePublisher(id, options);

        return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options)
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
        };
        },

    }
};

/**
 * PublisherControllerApi - factory interface
 * @export
 */
export const PublisherControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new Publisher
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options?: any) {
            return PublisherControllerApiFp(configuration).createPublisher(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).deletePublisher(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Publisher by id
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options?: any) {
            return PublisherControllerApiFp(configuration).editPublisher(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get All Publishers Id and Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublishers(options?: any) {
            return PublisherControllerApiFp(configuration).getAllPublishers(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Publisher Domains
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomains(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).getDomains(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Publisher by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).publisher(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Publishers
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherList(search?: string, options?: any) {
            return PublisherControllerApiFp(configuration).publisherList(search, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Publishers for group
         * @param {number} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherListByGroup(groupId: number, options?: any) {
            return PublisherControllerApiFp(configuration).publisherListByGroup(groupId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Publisher Transaction Start date
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionStartDate(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).transactionStartDate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update token by Publisher id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).updateToken(id, options)(fetch, basePath);
        },
    };
};

/**
 * PublisherControllerApi - object-oriented interface
 * @export
 * @class PublisherControllerApi
 * @extends {BaseAPI}
 */
export class PublisherControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Publisher
     * @param {PublisherBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public createPublisher(body: PublisherBean, options?: any) {
        return PublisherControllerApiFp(this.configuration).createPublisher(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Publisher by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public deletePublisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).deletePublisher(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Publisher by id
     * @param {PublisherBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public editPublisher(body: PublisherBean, id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).editPublisher(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get All Publishers Id and Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public getAllPublishers(options?: any) {
        return PublisherControllerApiFp(this.configuration).getAllPublishers(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Publisher Domains
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public getDomains(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).getDomains(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Publisher by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisher(id, options)(this.fetch, this.basePath);
    }


    // * @summary Download Text for Publisher by id
    // * @param {number} id
    // * @param {*} [options] Override http request option.
    // * @throws {RequiredError}
    // * @memberof PublisherControllerApi
    // */
    public downloadTxtFile(publisherId: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).downloadTxtFile(publisherId, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Download app-ads.txt file for Publisher by id
     * @param {number} publisherId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public downloadAppAdsTxtFile(publisherId: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).downloadAppAdsTxtFile(publisherId, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Get all Publishers
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisherList(search?: string, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisherList(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Publishers for group
     * @param {number} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisherListByGroup(groupId: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisherListByGroup(groupId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Publisher Transaction Start date
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public transactionStartDate(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).transactionStartDate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update token by Publisher id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public updateToken(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).updateToken(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Activate Publisher by id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public activatePublisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration)
            .activatePublisher(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Deactivate Publisher by id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public deactivatePublisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration)
            .deactivatePublisher(id, options)(this.fetch, this.basePath);
    }


}
/**
 * PublisherGroupControllerApi - fetch parameter creator
 * @export
 */
export const PublisherGroupControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a publisher group
         * @param {PublisherGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherGroup(body: PublisherGroupBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisherGroup.');
            }
            const localVarPath = `/api/group`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisherGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePublisherGroup.');
            }
            const localVarPath = `/api/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update report template by id
         * @param {PublisherGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisherGroup(body: PublisherGroupBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editPublisherGroup.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editPublisherGroup.');
            }
            const localVarPath = `/api/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPublisherGroup.');
            }
            const localVarPath = `/api/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all publisher groups
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroupList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/groups`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublisherGroupControllerApi - functional programming interface
 * @export
 */
export const PublisherGroupControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a publisher group
         * @param {PublisherGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherGroup(body: PublisherGroupBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherGroupBeanObject> {
            const localVarFetchArgs = PublisherGroupControllerApiFetchParamCreator(configuration).createPublisherGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisherGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PublisherGroupControllerApiFetchParamCreator(configuration).deletePublisherGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update report template by id
         * @param {PublisherGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisherGroup(body: PublisherGroupBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherGroupBeanObject> {
            const localVarFetchArgs = PublisherGroupControllerApiFetchParamCreator(configuration).editPublisherGroup(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherGroupBeanObject> {
            const localVarFetchArgs = PublisherGroupControllerApiFetchParamCreator(configuration).getPublisherGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all publisher groups
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroupList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherGroupBean> {
            const localVarFetchArgs = PublisherGroupControllerApiFetchParamCreator(configuration).getPublisherGroupList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PublisherGroupControllerApi - factory interface
 * @export
 */
export const PublisherGroupControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create a publisher group
         * @param {PublisherGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherGroup(body: PublisherGroupBean, options?: any) {
            return PublisherGroupControllerApiFp(configuration).createPublisherGroup(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisherGroup(id: number, options?: any) {
            return PublisherGroupControllerApiFp(configuration).deletePublisherGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update report template by id
         * @param {PublisherGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisherGroup(body: PublisherGroupBean, id: number, options?: any) {
            return PublisherGroupControllerApiFp(configuration).editPublisherGroup(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get publisher group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroup(id: number, options?: any) {
            return PublisherGroupControllerApiFp(configuration).getPublisherGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all publisher groups
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherGroupList(search?: string, options?: any) {
            return PublisherGroupControllerApiFp(configuration).getPublisherGroupList(search, options)(fetch, basePath);
        },
    };
};

/**
 * PublisherGroupControllerApi - object-oriented interface
 * @export
 * @class PublisherGroupControllerApi
 * @extends {BaseAPI}
 */
export class PublisherGroupControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create a publisher group
     * @param {PublisherGroupBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherGroupControllerApi
     */
    public createPublisherGroup(body: PublisherGroupBean, options?: any) {
        return PublisherGroupControllerApiFp(this.configuration).createPublisherGroup(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete publisher group by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherGroupControllerApi
     */
    public deletePublisherGroup(id: number, options?: any) {
        return PublisherGroupControllerApiFp(this.configuration).deletePublisherGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update report template by id
     * @param {PublisherGroupBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherGroupControllerApi
     */
    public editPublisherGroup(body: PublisherGroupBean, id: number, options?: any) {
        return PublisherGroupControllerApiFp(this.configuration).editPublisherGroup(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get publisher group by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherGroupControllerApi
     */
    public getPublisherGroup(id: number, options?: any) {
        return PublisherGroupControllerApiFp(this.configuration).getPublisherGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all publisher groups
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherGroupControllerApi
     */
    public getPublisherGroupList(search?: string, options?: any) {
        return PublisherGroupControllerApiFp(this.configuration).getPublisherGroupList(search, options)(this.fetch, this.basePath);
    }

}
/**
 * ReportControllerApi - fetch parameter creator
 * @export
 */
export const ReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DspReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDspReport(body: DspReportRequestParameters, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createDspReport.');
            }
            const localVarPath = `/api/report/create/dsp`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspReportRequestParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublisherReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherReport(body: PublisherReportRequestParameters, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisherReport.');
            }
            const localVarPath = `/api/report/create/publisher`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherReportRequestParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
         /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherDashboardReport(body: any, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisherDashboardReport.');
            }
            const localVarPath = `/api/dashboard/create/publisher`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherReportRequestParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopNPublisherReport(body: any, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createTopNPublisherReport.');
            }
            const localVarPath = `/api/dashboard/topn/publisher`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RawReportRequestParameters} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherDomains(body: any, options: any = {}): FetchArgs {
            // Validate the required parameters
            if (!body?.publisherId) {
                throw new RequiredError('id, fromDate, or toDate', 'Required parameters were not provided when calling getPublisherDomains.');
            }
        
            const localVarPath = `/api/dashboard/domains/${parseFloat(body?.publisherId)}`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            
            // Prepare query parameters to pass in the URL
            const localVarQueryParameter = {
                // id: parseFloat(body?.publisherId),
                startDate: body?.fromDate,
                endDate: body?.toDate
            };
        
            // Merge the query parameters with any additional query parameters from `options.query`
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
        
            // Set up the request options
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
        
            // Set content type header for the GET request
            localVarHeaderParameter['Content-Type'] = 'application/json';
        
            // Merge headers with any additional headers from `options.headers`
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
        
            // No body is needed for a GET request
            localVarRequestOptions.body = null;
        
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherMobileAppIds(body: any, options: any = {}): FetchArgs {
            // Validate the required parameters
            if (!body?.publisherId) {
                throw new RequiredError('id, fromDate, or toDate', 'Required parameters were not provided when calling getPublisherMobileAppIds.');
            }
        
            const localVarPath = '/api/publisher/mobileAppIds';
            const localVarUrlObj: any = url.parse(localVarPath, true);
            
            // Prepare query parameters to pass in the URL
            const localVarQueryParameter = {
                id: parseFloat(body?.publisherId),
                fromDate: body?.fromDate,
                toDate: body?.toDate
            };
        
            // Merge the query parameters with any additional query parameters from `options.query`
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
        
            // Set up the request options
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
        
            // Set content type header for the GET request
            localVarHeaderParameter['Content-Type'] = 'application/json';
        
            // Merge headers with any additional headers from `options.headers`
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
        
            // No body is needed for a GET request
            localVarRequestOptions.body = null;
        
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        
        createRawReport(body: RawReportRequestParameters, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createRawReport.');
            }
            const localVarPath = `/api/report/create/raw`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RawReportRequestParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getReport.');
            }
            const localVarPath = `/api/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionStartDate(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTransactionStartDate.');
            }
            const localVarPath = `/api/publisher/transactionStartDate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            console.log(url.format(localVarUrlObj),localVarRequestOptions,'hyyyyy')
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherReportColumns(options: any = {}): FetchArgs {
            const localVarPath = `/api/report/publisher/columns`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDspReportColumns(options: any = {}): FetchArgs {
            const localVarPath = `/api/report/dsp/columns`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportInfo.');
            }
            const localVarPath = `/api/report/info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DspReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDspReport(body: DspReportRequestParameters, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createDspReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {PublisherReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherReport(body: PublisherReportRequestParameters, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createPublisherReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherDashboardReport(body: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createPublisherDashboardReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopNPublisherReport(body: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createTopNPublisherReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {RawReportRequestParameters} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherDomains(body: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getPublisherDomains(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherMobileAppIds(body: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getPublisherMobileAppIds(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRawReport(body: RawReportRequestParameters, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseUUIDObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).createRawReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionStartDate(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getTransactionStartDate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url).then((response) => {

                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherReportColumns(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ columns: string[], groupBy: string[] }> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getPublisherReportColumns(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDspReportColumns(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ columns: string[], groupBy: string[] }> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).getDspReportColumns(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseReportBeanObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).reportInfo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {DspReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDspReport(body: DspReportRequestParameters, options?: any) {
            return ReportControllerApiFp(configuration).createDspReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {PublisherReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisherReport(body: PublisherReportRequestParameters, options?: any) {
            return ReportControllerApiFp(configuration).createPublisherReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RawReportRequestParameters} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRawReport(body: RawReportRequestParameters, options?: any) {
            return ReportControllerApiFp(configuration).createRawReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(id: string, options?: any) {
            return ReportControllerApiFp(configuration).getReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionStartDate(id: string, options?: any) {
            console.log(id,'helloooo')
            return ReportControllerApiFp(configuration).getTransactionStartDate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInfo(id: string, options?: any) {
            return ReportControllerApiFp(configuration).reportInfo(id, options)(fetch, basePath);
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {DspReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createDspReport(body: DspReportRequestParameters, options?: any) {
        return ReportControllerApiFp(this.configuration).createDspReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {PublisherReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createPublisherReport(body: PublisherReportRequestParameters, options?: any) {
        return ReportControllerApiFp(this.configuration).createPublisherReport(body, options)(this.fetch, this.basePath);
    }
    /**
     * 
     * @param {PublisherReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createPublisherDashboardReport(body: any, options?: any) {
        return ReportControllerApiFp(this.configuration).createPublisherDashboardReport(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createTopNPublisherReport(body: any, options?: any) {
        return ReportControllerApiFp(this.configuration).createTopNPublisherReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RawReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getPublisherDomains(body: any, options?: any) {
        return ReportControllerApiFp(this.configuration).getPublisherDomains(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RawReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getPublisherMobileAppIds(body: any, options?: any) {
        return ReportControllerApiFp(this.configuration).getPublisherMobileAppIds(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RawReportRequestParameters} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public createRawReport(body: RawReportRequestParameters, options?: any) {
        return ReportControllerApiFp(this.configuration).createRawReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getReport(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).getReport(id, options)(this.fetch, this.basePath);
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getTransactionStartDate(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).getTransactionStartDate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public reportInfo(id: string, options?: any) {
        return ReportControllerApiFp(this.configuration).reportInfo(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getPublisherReportColumns(options?: any) {
        return ReportControllerApiFp(this.configuration).getPublisherReportColumns(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public getDspReportColumns(options?: any) {
        return ReportControllerApiFp(this.configuration).getDspReportColumns(options)(this.fetch, this.basePath);
    }

}
/**
 * ReportTemplateControllerApi - fetch parameter creator
 * @export
 */
export const ReportTemplateControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create report template
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createReportTemplate.');
            }
            const localVarPath = `/api/template`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportTemplateRequestReportRequestParametersObjectObject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportTemplate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteReportTemplate.');
            }
            const localVarPath = `/api/report-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update report template by id
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editReportTemplate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editReportTemplate.');
            }
            const localVarPath = `/api/report-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportTemplateRequestReportRequestParametersObjectObject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getReportTemplate.');
            }
            const localVarPath = `/api/report-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all report templates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplateList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/templates`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportTemplateControllerApi - functional programming interface
 * @export
 */
export const ReportTemplateControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create report template
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseBooleanObject> {
            const localVarFetchArgs = ReportTemplateControllerApiFetchParamCreator(configuration).createReportTemplate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportTemplate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportTemplateControllerApiFetchParamCreator(configuration).deleteReportTemplate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update report template by id
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseReportTemplateRequestObject> {
            const localVarFetchArgs = ReportTemplateControllerApiFetchParamCreator(configuration).editReportTemplate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseReportTemplateRequestObject> {
            const localVarFetchArgs = ReportTemplateControllerApiFetchParamCreator(configuration).getReportTemplate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all report templates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplateList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseReportTemplateRequestObject> {
            const localVarFetchArgs = ReportTemplateControllerApiFetchParamCreator(configuration).getReportTemplateList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReportTemplateControllerApi - factory interface
 * @export
 */
export const ReportTemplateControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create report template
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, options?: any) {
            return ReportTemplateControllerApiFp(configuration).createReportTemplate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportTemplate(id: number, options?: any) {
            return ReportTemplateControllerApiFp(configuration).deleteReportTemplate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update report template by id
         * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, id: number, options?: any) {
            return ReportTemplateControllerApiFp(configuration).editReportTemplate(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get report template by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplate(id: number, options?: any) {
            return ReportTemplateControllerApiFp(configuration).getReportTemplate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all report templates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTemplateList(search?: string, options?: any) {
            return ReportTemplateControllerApiFp(configuration).getReportTemplateList(search, options)(fetch, basePath);
        },
    };
};

/**
 * ReportTemplateControllerApi - object-oriented interface
 * @export
 * @class ReportTemplateControllerApi
 * @extends {BaseAPI}
 */
export class ReportTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create report template
     * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplateControllerApi
     */
    public createReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, options?: any) {
        return ReportTemplateControllerApiFp(this.configuration).createReportTemplate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete report template by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplateControllerApi
     */
    public deleteReportTemplate(id: number, options?: any) {
        return ReportTemplateControllerApiFp(this.configuration).deleteReportTemplate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update report template by id
     * @param {ReportTemplateRequestReportRequestParametersObjectObject} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplateControllerApi
     */
    public editReportTemplate(body: ReportTemplateRequestReportRequestParametersObjectObject, id: number, options?: any) {
        return ReportTemplateControllerApiFp(this.configuration).editReportTemplate(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get report template by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplateControllerApi
     */
    public getReportTemplate(id: number, options?: any) {
        return ReportTemplateControllerApiFp(this.configuration).getReportTemplate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all report templates
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplateControllerApi
     */
    public getReportTemplateList(search?: string, options?: any) {
        return ReportTemplateControllerApiFp(this.configuration).getReportTemplateList(search, options)(this.fetch, this.basePath);
    }

}
/**
 * ScheduledReportControllerApi - fetch parameter creator
 * @export
 */
export const ScheduledReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createScheduledReport.');
            }
            const localVarPath = `/api/scheduled-report`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScheduledReportRequestReportRequestParametersObjectObject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledReport(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteScheduledReport.');
            }
            const localVarPath = `/api/scheduled-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Scheduled report by id
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editScheduledReport.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editScheduledReport.');
            }
            const localVarPath = `/api/scheduled-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ScheduledReportRequestReportRequestParametersObjectObject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReport(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getScheduledReport.');
            }
            const localVarPath = `/api/scheduled-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Scheduled reports
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReportList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/scheduled-report`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledReportControllerApi - functional programming interface
 * @export
 */
export const ScheduledReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseBooleanObject> {
            const localVarFetchArgs = ScheduledReportControllerApiFetchParamCreator(configuration).createScheduledReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledReport(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ScheduledReportControllerApiFetchParamCreator(configuration).deleteScheduledReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update Scheduled report by id
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseScheduledReportRequestObject> {
            const localVarFetchArgs = ScheduledReportControllerApiFetchParamCreator(configuration).editScheduledReport(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReport(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseScheduledReportRequestObject> {
            const localVarFetchArgs = ScheduledReportControllerApiFetchParamCreator(configuration).getScheduledReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Scheduled reports
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReportList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseScheduledReportRequestObject> {
            const localVarFetchArgs = ScheduledReportControllerApiFetchParamCreator(configuration).getScheduledReportList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ScheduledReportControllerApi - factory interface
 * @export
 */
export const ScheduledReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, options?: any) {
            return ScheduledReportControllerApiFp(configuration).createScheduledReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledReport(id: number, options?: any) {
            return ScheduledReportControllerApiFp(configuration).deleteScheduledReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update Scheduled report by id
         * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, id: number, options?: any) {
            return ScheduledReportControllerApiFp(configuration).editScheduledReport(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Scheduled report by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReport(id: number, options?: any) {
            return ScheduledReportControllerApiFp(configuration).getScheduledReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Scheduled reports
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledReportList(search?: string, options?: any) {
            return ScheduledReportControllerApiFp(configuration).getScheduledReportList(search, options)(fetch, basePath);
        },
    };
};

/**
 * ScheduledReportControllerApi - object-oriented interface
 * @export
 * @class ScheduledReportControllerApi
 * @extends {BaseAPI}
 */
export class ScheduledReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledReportControllerApi
     */
    public createScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, options?: any) {
        return ScheduledReportControllerApiFp(this.configuration).createScheduledReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Scheduled report by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledReportControllerApi
     */
    public deleteScheduledReport(id: number, options?: any) {
        return ScheduledReportControllerApiFp(this.configuration).deleteScheduledReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update Scheduled report by id
     * @param {ScheduledReportRequestReportRequestParametersObjectObject} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledReportControllerApi
     */
    public editScheduledReport(body: ScheduledReportRequestReportRequestParametersObjectObject, id: number, options?: any) {
        return ScheduledReportControllerApiFp(this.configuration).editScheduledReport(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Scheduled report by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledReportControllerApi
     */
    public getScheduledReport(id: number, options?: any) {
        return ScheduledReportControllerApiFp(this.configuration).getScheduledReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Scheduled reports
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledReportControllerApi
     */
    public getScheduledReportList(search?: string, options?: any) {
        return ScheduledReportControllerApiFp(this.configuration).getScheduledReportList(search, options)(this.fetch, this.basePath);
    }

}
/**
 * SovTemplateControllerApi - fetch parameter creator
 * @export
 */
export const SovTemplateControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new SOVTemplate
         * @param {SOVTemplateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSovTemplate(body: SOVTemplateBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSovTemplate.');
            }
            const localVarPath = `/api/sov`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SOVTemplateBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSovTemplate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSovTemplate.');
            }
            const localVarPath = `/api/sov/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update SOVTemplate by id
         * @param {SOVTemplateBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSovTemplate(body: SOVTemplateBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSovTemplate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSovTemplate.');
            }
            const localVarPath = `/api/sov/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SOVTemplateBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sovTemplate.');
            }
            const localVarPath = `/api/sov/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all SOVTemplates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplateList(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/sov`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SovTemplateControllerApi - functional programming interface
 * @export
 */
export const SovTemplateControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new SOVTemplate
         * @param {SOVTemplateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSovTemplate(body: SOVTemplateBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSOVTemplateBeanObject> {
            const localVarFetchArgs = SovTemplateControllerApiFetchParamCreator(configuration).createSovTemplate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSovTemplate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SovTemplateControllerApiFetchParamCreator(configuration).deleteSovTemplate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update SOVTemplate by id
         * @param {SOVTemplateBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSovTemplate(body: SOVTemplateBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSOVTemplateBeanObject> {
            const localVarFetchArgs = SovTemplateControllerApiFetchParamCreator(configuration).editSovTemplate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSOVTemplateBeanObject> {
            const localVarFetchArgs = SovTemplateControllerApiFetchParamCreator(configuration).sovTemplate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all SOVTemplates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplateList(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSOVTemplateBean> {
            const localVarFetchArgs = SovTemplateControllerApiFetchParamCreator(configuration).sovTemplateList(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SovTemplateControllerApi - factory interface
 * @export
 */
export const SovTemplateControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new SOVTemplate
         * @param {SOVTemplateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSovTemplate(body: SOVTemplateBean, options?: any) {
            return SovTemplateControllerApiFp(configuration).createSovTemplate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSovTemplate(id: number, options?: any) {
            return SovTemplateControllerApiFp(configuration).deleteSovTemplate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update SOVTemplate by id
         * @param {SOVTemplateBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSovTemplate(body: SOVTemplateBean, id: number, options?: any) {
            return SovTemplateControllerApiFp(configuration).editSovTemplate(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get SOVTemplate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplate(id: number, options?: any) {
            return SovTemplateControllerApiFp(configuration).sovTemplate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all SOVTemplates
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sovTemplateList(search?: string, options?: any) {
            return SovTemplateControllerApiFp(configuration).sovTemplateList(search, options)(fetch, basePath);
        },
    };
};

/**
 * SovTemplateControllerApi - object-oriented interface
 * @export
 * @class SovTemplateControllerApi
 * @extends {BaseAPI}
 */
export class SovTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new SOVTemplate
     * @param {SOVTemplateBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SovTemplateControllerApi
     */
    public createSovTemplate(body: SOVTemplateBean, options?: any) {
        return SovTemplateControllerApiFp(this.configuration).createSovTemplate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete SOVTemplate by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SovTemplateControllerApi
     */
    public deleteSovTemplate(id: number, options?: any) {
        return SovTemplateControllerApiFp(this.configuration).deleteSovTemplate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update SOVTemplate by id
     * @param {SOVTemplateBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SovTemplateControllerApi
     */
    public editSovTemplate(body: SOVTemplateBean, id: number, options?: any) {
        return SovTemplateControllerApiFp(this.configuration).editSovTemplate(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get SOVTemplate by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SovTemplateControllerApi
     */
    public sovTemplate(id: number, options?: any) {
        return SovTemplateControllerApiFp(this.configuration).sovTemplate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all SOVTemplates
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SovTemplateControllerApi
     */
    public sovTemplateList(search?: string, options?: any) {
        return SovTemplateControllerApiFp(this.configuration).sovTemplateList(search, options)(this.fetch, this.basePath);
    }

}
/**
 * TransactionControllerApi - fetch parameter creator
 * @export
 */
export const TransactionControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Match transaction with hash
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchHash(body: ValidationRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling matchHash.');
            }
            const localVarPath = `/api/match-transaction`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ValidationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction data from centralised db
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transaction(body: ValidationRequest, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling transaction.');
            }
            const localVarPath = `/api/transaction`;
            const localVarUrlObj : any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ValidationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionControllerApi - functional programming interface
 * @export
 */
export const TransactionControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Match transaction with hash
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchHash(body: ValidationRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
            const localVarFetchArgs = TransactionControllerApiFetchParamCreator(configuration).matchHash(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get transaction data from centralised db
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transaction(body: ValidationRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: string; }> {
            const localVarFetchArgs = TransactionControllerApiFetchParamCreator(configuration).transaction(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TransactionControllerApi - factory interface
 * @export
 */
export const TransactionControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Match transaction with hash
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchHash(body: ValidationRequest, options?: any) {
            return TransactionControllerApiFp(configuration).matchHash(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get transaction data from centralised db
         * @param {ValidationRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transaction(body: ValidationRequest, options?: any) {
            return TransactionControllerApiFp(configuration).transaction(body, options)(fetch, basePath);
        },
    };
};

/**
 * TransactionControllerApi - object-oriented interface
 * @export
 * @class TransactionControllerApi
 * @extends {BaseAPI}
 */
export class TransactionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Match transaction with hash
     * @param {ValidationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    public matchHash(body: ValidationRequest, options?: any) {
        return TransactionControllerApiFp(this.configuration).matchHash(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get transaction data from centralised db
     * @param {ValidationRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    public transaction(body: ValidationRequest, options?: any) {
        return TransactionControllerApiFp(this.configuration).transaction(body, options)(this.fetch, this.basePath);
    }

}

/**
 * DomainCategoryControllerApi - fetch parameter creator
 * @export
 */
export const DomainCategoryControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Search domain categories
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDomainCategories(search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/domain-category/search`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a domain category
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainCategory(body: any, options: any = {}): FetchArgs {
            const localVarPath = `/api/domain-category`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = JSON.stringify(body);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get domains by category IDs
         * @param {Array<number>} categoryIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainsByCategories(categoryIds: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/api/domain-category/domains`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds.join(',');
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get mobile app IDs by category IDs
         * @param {Array<number>} categoryIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileAppIdsByCategories(categoryIds: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/api/domain-category/mobile-app-ids`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds.join(',');
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DomainCategoryControllerApi - functional programming interface
 * @export
 */
export const DomainCategoryControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Search domain categories
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDomainCategories(search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DomainCategoryControllerApiFetchParamCreator(configuration).searchDomainCategories(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create a domain category
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainCategory(body: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DomainCategoryControllerApiFetchParamCreator(configuration).createDomainCategory(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get domains by category IDs
         * @param {Array<number>} categoryIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainsByCategories(categoryIds: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DomainCategoryControllerApiFetchParamCreator(configuration).getDomainsByCategories(categoryIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get mobile app IDs by category IDs
         * @param {Array<number>} categoryIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMobileAppIdsByCategories(categoryIds: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DomainCategoryControllerApiFetchParamCreator(configuration).getMobileAppIdsByCategories(categoryIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DomainCategoryControllerApi - object-oriented interface
 * @export
 * @class DomainCategoryControllerApi
 * @extends {BaseAPI}
 */
export class DomainCategoryControllerApi extends BaseAPI {
    /**
     *
     * @summary Search domain categories
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainCategoryControllerApi
     */
    public searchDomainCategories(search?: string, options?: any) {
        return DomainCategoryControllerApiFp(this.configuration).searchDomainCategories(search, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Create a domain category
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainCategoryControllerApi
     */
    public createDomainCategory(body: any, options?: any) {
        return DomainCategoryControllerApiFp(this.configuration).createDomainCategory(body, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Get domains by category IDs
     * @param {Array<number>} categoryIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainCategoryControllerApi
     */
    public getDomainsByCategories(categoryIds: Array<number>, options?: any) {
        return DomainCategoryControllerApiFp(this.configuration).getDomainsByCategories(categoryIds, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Get mobile app IDs by category IDs
     * @param {Array<number>} categoryIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainCategoryControllerApi
     */
    public getMobileAppIdsByCategories(categoryIds: Array<number>, options?: any) {
        return DomainCategoryControllerApiFp(this.configuration).getMobileAppIdsByCategories(categoryIds, options)(this.fetch, this.basePath);
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// AuditControllerApi  —  POST /api/audit/report
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Request body for the audit / change-log report endpoint.
 * @export
 * @interface AuditReportRequest
 */
export interface AuditReportRequest {
    /**
     * Entity type: "PUBLISHER" | "DSP" | "DEAL"
     * @type {string}
     * @memberof AuditReportRequest
     */
    entityType: string;
    /**
     * ID of the entity being audited.
     * @type {number | string}
     * @memberof AuditReportRequest
     */
    entityId: number | string;
    /**
     * Start of the date range, format "YYYY-MM-DD HH:mm"
     * @type {string}
     * @memberof AuditReportRequest
     */
    startDate: string;
    /**
     * End of the date range, format "YYYY-MM-DD HH:mm"
     * @type {string}
     * @memberof AuditReportRequest
     */
    endDate: string;
}

/**
 * A single field change within one audit record.
 * @export
 * @interface AuditFieldChange
 */
export interface AuditFieldChange {
    /**
     * Value before the change.
     * @type {string}
     * @memberof AuditFieldChange
     */
    previousValue?: string;
    /**
     * Value after the change.
     * @type {string}
     * @memberof AuditFieldChange
     */
    currentValue?: string;
}

/**
 * One audit record returned by the API.
 * A single record can contain multiple field changes in changeLogMap.
 * @export
 * @interface AuditRecord
 */
export interface AuditRecord {
    /**
     * Username / email of the person who made the change.
     * @type {string}
     * @memberof AuditRecord
     */
    changedBy?: string;
    /**
     * Timestamp of the change, e.g. "2026-02-20 09:40:08"
     * @type {string}
     * @memberof AuditRecord
     */
    changedTime?: string;
    /**
     * Action type, e.g. "Update"
     * @type {string}
     * @memberof AuditRecord
     */
    action?: string;
    /**
     * Map of field name → { previousValue, currentValue }
     * @type {{ [key: string]: AuditFieldChange }}
     * @memberof AuditRecord
     */
    changeLogMap?: { [key: string]: AuditFieldChange };
}

/**
 * @export
 * @interface ListResponseAuditRecord
 */
export interface ListResponseAuditRecord {
    /**
     * @type {Array<AuditRecord>}
     * @memberof ListResponseAuditRecord
     */
    data?: Array<AuditRecord>;
}

/**
 * @export
 * AuditControllerApiFetchParamCreator
 */
export const AuditControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch the audit / change-log report for a given entity and date range.
         * @param {AuditReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditReport(body: AuditReportRequest, options: any = {}): FetchArgs {
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling auditReport.');
            }
            const localVarPath = `/api/audit/report`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AuditReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * @export
 * AuditControllerApiFp
 */
export const AuditControllerApiFp = function (configuration?: Configuration) {
    return {
        /**
         * @param {AuditReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditReport(body: AuditReportRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AuditRecord>> {
            const localVarFetchArgs = AuditControllerApiFetchParamCreator(configuration).auditReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    };
};

/**
 * AuditControllerApi — wraps POST /api/audit/report
 * @export
 * @class AuditControllerApi
 * @extends {BaseAPI}
 */
export class AuditControllerApi extends BaseAPI {
    /**
     * Fetch the audit / change-log report for a given entity and date range.
     * @param {AuditReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditControllerApi
     */
    public auditReport(body: AuditReportRequest, options?: any) {
        return AuditControllerApiFp(this.configuration).auditReport(body, options)(this.fetch, this.basePath);
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// RejectionReasonControllerApi
// ─────────────────────────────────────────────────────────────────────────────

// ─── Types ───────────────────────────────────────────────────────────────────

export type RejectionConfigType = 'pub' | 'dsp';
export type RejectionConfigStatus = 'NOT_STARTED' | 'RECORDING' | 'STOPPED';
export type RejectionGranularity = 'daily' | 'hourly';
export type RejectionDurationMinutes = 2 | 10 | 30 | 60;

export interface RejectionStatsConfigBean {
    id: number;
    type: 'PUB' | 'DSP';
    publisherIds: number[];
    dspIds: number[];
    durationMinutes: RejectionDurationMinutes;
    status: RejectionConfigStatus;
    recordStartTime: string | null;
    recordStopTime: string | null;
}

export interface RejectionStatsConfigUpdateRequest {
    type: 'PUB' | 'DSP';
    publisherIds: number[];
    dspIds?: number[];
    durationMinutes: RejectionDurationMinutes;
}

export interface RejectionStatsRequestBean {
    fromDate: string;
    toDate: string;
    publisherIds?: number[];
    dspIds?: number[];
    granularity: RejectionGranularity;
}

export interface RejectionStatResponseBean {
    date: string;
    hour: number | null;
    publisherId: number;
    dspId: number;
    rejectionReason: string;
    requestCount: number;
}

export type FeatureFlagMap = Record<string, boolean>;

// ─── FetchParamCreator ────────────────────────────────────────────────────────

export const RejectionReasonControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {

        getFeatureFlag(name: string, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/feature-flags/${encodeURIComponent(String(name))}`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        getConfig(type: RejectionConfigType, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/${encodeURIComponent(String(type))}`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        updateConfig(type: RejectionConfigType, body: RejectionStatsConfigUpdateRequest, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/${encodeURIComponent(String(type))}`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });
            const needsSerialization = (<any>"RejectionStatsConfigUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        startCapture(type: RejectionConfigType, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/${encodeURIComponent(String(type))}/start`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        stopCapture(type: RejectionConfigType, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/${encodeURIComponent(String(type))}/stop`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        getPublisherRejectionStats(body: RejectionStatsRequestBean, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/pub-rej-stats`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });
            const needsSerialization = (<any>"RejectionStatsRequestBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },

        getDspRejectionStats(body: RejectionStatsRequestBean, options: any = {}): FetchArgs {
            const headersX = document.cookie.split("=");
            const localVarPath = `/api/rejection-stats-config/dsp-rej-stats`;
            const localVarUrlObj: any = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers, { [headersX[0]]: headersX[1] });
            const needsSerialization = (<any>"RejectionStatsRequestBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

// ─── Fp ───────────────────────────────────────────────────────────────────────

export const RejectionReasonControllerApiFp = function (configuration?: Configuration) {
    return {

        getFeatureFlag(name: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FeatureFlagMap> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).getFeatureFlag(name, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        getConfig(type: RejectionConfigType, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatsConfigBean> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).getConfig(type, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        updateConfig(type: RejectionConfigType, body: RejectionStatsConfigUpdateRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatsConfigBean> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).updateConfig(type, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        startCapture(type: RejectionConfigType, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatsConfigBean> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).startCapture(type, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        stopCapture(type: RejectionConfigType, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatsConfigBean> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).stopCapture(type, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        getPublisherRejectionStats(body: RejectionStatsRequestBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatResponseBean[]> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).getPublisherRejectionStats(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },

        getDspRejectionStats(body: RejectionStatsRequestBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RejectionStatResponseBean[]> {
            const localVarFetchArgs = RejectionReasonControllerApiFetchParamCreator(configuration).getDspRejectionStats(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    };
};

// ─── Class ────────────────────────────────────────────────────────────────────

export class RejectionReasonControllerApi extends BaseAPI {

    public getFeatureFlag(name: string, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).getFeatureFlag(name, options)(this.fetch, this.basePath);
    }

    public getConfig(type: RejectionConfigType, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).getConfig(type, options)(this.fetch, this.basePath);
    }

    public updateConfig(type: RejectionConfigType, body: RejectionStatsConfigUpdateRequest, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).updateConfig(type, body, options)(this.fetch, this.basePath);
    }

    public startCapture(type: RejectionConfigType, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).startCapture(type, options)(this.fetch, this.basePath);
    }

    public stopCapture(type: RejectionConfigType, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).stopCapture(type, options)(this.fetch, this.basePath);
    }

    public getPublisherRejectionStats(body: RejectionStatsRequestBean, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).getPublisherRejectionStats(body, options)(this.fetch, this.basePath);
    }

    public getDspRejectionStats(body: RejectionStatsRequestBean, options?: any) {
        return RejectionReasonControllerApiFp(this.configuration).getDspRejectionStats(body, options)(this.fetch, this.basePath);
    }
}